export default {
    "generalErrorMessage": {
        "fieldIsRequired": "Le champ est requis",
        "something_went_wrong": "Quelque chose s'est mal passé",
        "field_required": "Ce champ est obligatoire"
    },
    "authErrorMessage": {
        "emailError": "Le champ email doit être une adresse email valide",
        "passwordValid": "Le champ mot de passe doit comporter au moins 8 caractères",
        "validPassRegex": "Les mots de passe doivent comporter au moins 8 caractères, inclure au moins 1 lettre minuscule, 1 lettre majuscule, 1 chiffre et 1 caractère spécial",
        "confirmPasswordValid": "La confirmation du mot de passe ne correspond pas",
        "validCharactersfirst": "Le champ prénom ne peut contenir que des caractères alphabétiques et des espaces",
        "validCharacterslast": "Le champ nom de famille ne peut contenir que des caractères alphabétiques et des espaces",
        "minMust": "doit comporter au moins 3 caractères",
        "must_be_a_valid_email": "Doit être un email valide",
        "currentPassword": "les mots de passe actuels doivent comporter au moins 8 caractères et contenir au moins 1 alphabet, 1 majuscule, 1 numérique et 1 caractère spécial",
        "newPassword": "les nouveaux mots de passe doivent comporter au moins 8 caractères et contenir au moins 1 alphabet, 1 majuscule, 1 numérique et 1 caractère spécial",
        "currentPasswordValid": "Le champ du mot de passe actuel doit contenir au moins 8 caractères",
        "newPasswordValid": "Le champ du nouveau mot de passe doit contenir au moins 8 caractères",
        "please_wait_before_resending_email": "Veuillez vérifier votre e-mail. Si vous ne l'avez pas reçu, vous pouvez renvoyer l'e-mail de vérification après 1 minute."
    },
    "companyErrorMessage": {
        "phoneNumberValid": "Le champ numéro de téléphone doit comporter au moins 10 caractères",
        "Something_went_wrong_Please_contact_to_admin": "Un problème est survenu. Veuillez contacter l'administrateur."
    },
    "errorPage": {
        "project_name": "Nom du projet",
        "project_key": "Clé du projet",
        "project_category": "Catégorie du projet",
        "team_name": "nom de l'équipe",
        "The": "Le",
        "field_must_be_a_valid": "le champ doit être valide",
        "email": "email",
        "password": "Mot de passe",
        "first_name": "prénom",
        "last_name": "nom",
        "company_name": "nom de l'entreprise",
        "file_extension": "extension de fichier",
        "milestone_status": "statut de l'étape",
        "name": "nom",
        "phone_number": "numéro de téléphone",
        "field_must_be_at_least": "le champ doit contenir au moins",
        "number": "nombre",
        "characters": "caractères",
        "digits": "chiffres",
        "priority_name": "nom de la priorité",
        "firstName": "prénom",
        "lastName": "nom",
        "phoneNumber": "numéro de téléphone",
        "must_be_less_than": "doit être inférieur à",
        "amount": "montant",
        "phone": "téléphone",
        "country": "Pays",
        "state": "État",
        "city": "Ville",
        "templatename": "nom du modèle",
        "description": "description",
        "Template_name_is_required": "Le nom du modèle est requis",
        "This_template_name_is_required.": "Ce nom de modèle est requis.",
        "status": "statut",
        "zipcode": "code postal",
        "address2": "adresse 2",
        "address1": "adresse 1",
        "The_confirm_password_field_is_required": "Le champ de confirmation du mot de passe est requis",
        "The_confirm_password_confirmation_does_not_match": "La confirmation du mot de passe ne correspond pas",
        "terms_and_condition": "termes et conditions",
        "category_name": "Nom de la catégorie",
        "channel_name": "Nom de la chaîne",
        "please_select_template": "Veuillez sélectionner un modèle",
        "template_name_already_exists": "Le nom du modèle existe déjà",
        "This_template_name_is_required": "Le nom de ce modèle est requis",
        "select_a_date": "Sélectionner une date",
        "amount_per_hours": "Montant par heure",
        "refundamount": "Montant du remboursement",
        "project_duedate": "Date d'échéance du projet",
        "project_lead_assignee": "Attribué au responsable du projet",
        "current_password": "Mot de passe actuel",
        "new_password": "Nouveau mot de passe",
        "confirm_password": "Confirmez le mot de passe",
        "This_template_name_is_already_exists": "Ce nom de modèle existe déjà.",
        "card_name": "nom de la carte",
        "topic": "sujet",
        "target_audience": "public cible",
        "keywords": "mots-clés",
        "content_purpose": "objectif du contenu",
        "product/service": "produit/service",
        "campaign_goals": "objectifs de campagne",
        "value_proposition": "proposition de valeur",
        "objectives": "objectifs",
        "key_message": "message clé",
        "problem": "problème",
        "context": "contexte",
        "constraints": "contraintes",
        "main_keyword": "mot-clé principal",
        "secondary_keywords": "mots-clés secondaires",
        "content_goal": "objectif du contenu",
        "keyword_list": "liste de mots-clés",
        "questions": "questions",
        "product_description": "description du produit",
        "feedback_data": "données de retour",
        "survey_questions": "questions d'enquête",
        "project": "projet",
        "progress_made": "progrès réalisés",
        "next_steps": "prochaines étapes",
        "key_features": "caractéristiques clés",
        "client_type": "type de client",
        "challenges": "défis",
        "results": "résultats",
        "event_type": "type d'événement",
        "cta": "appel à l'action",
        "campaign_objectives": "objectifs de campagne",
        "survey_objectives": "objectifs d'enquête",
        "column_one_name": "nom de la première colonne",
        "column_two_name": "nom de la deuxième colonne",
        "column_one_data": "données de la première colonne",
        "column_two_data": "données de la deuxième colonne",
        "customer_name": "nom du client",
        "email_purpose": "objectif de l'email",
        "talking_points": "points de discussion",
        "product_name": "nom du produit",
        "about_the_product": "à propos du produit",
        "core_problem_it_solves": "problème principal qu'il résout",
        "what_makes_it_different": "ce qui le rend différent",
        "the_product_is": "le produit est",
        "core_differentiators": "différenciateurs clés",
        "product/service_benefits": "avantages du produit/service",
        "call_notes": "notes d'appel",
        "call_transcript": "transcription d'appel",
        "target_company": "entreprise cible",
        "use_case": "cas d'usage",
        "customer_challenges": "défis du client",
        "territories": "territoires",
        "target_industries": "industries cibles",
        "sales_goals": "objectifs de vente",
        "sales_strategies": "stratégies de vente",
        "transcript": "transcription",
        "pain_points": "points de douleur",
        "company_type": "type d'entreprise",
        "sales_cycle_stages": "étapes du cycle de vente",
        "sales_methodologies": "méthodologies de vente",
        "key_skills": "compétences clés",
        "training_formats": "formats de formation",
        "participants": "participants",
        "target_industry": "industrie cible",
        "value_statement": "déclaration de valeur",
        "meeting_type": "type de réunion",
        "your_talking_points": "vos points de discussion",
        "goal": "objectif",
        "reasons_for_canceling": "raisons d'annulation",
        "incentive": "incitation",
        "unique_selling_points": "points de vente uniques",
        "desired_format": "format souhaité",
        "topics": "sujets",
        "content": "contenu",
        "stakeholders": "parties prenantes",
        "sales_notes": "notes de vente",
        "customer_goals": "objectifs du client",
        "teams_impacted": "équipes impactées",
        "requirements": "exigences",
        "goals_met": "objectifs atteints",
        "project_stakeholders": "parties prenantes du projet",
        "opportunities": "opportunités",
        "risks": "risques",
        "customer_message": "message du client",
        "date_range": "plage de dates",
        "project_notes": "notes du projet",
        "project_description": "description du projet",
        "name_of_project": "nom du projet",
        "date_ranges": "plages de dates",
        "requestor": "demandeur",
        "requests": "demandes",
        "reason_for_the_change": "raison du changement",
        "expected_impact_of_the_change": "impact attendu du changement",
        "project_goals": "objectifs du projet",
        "participant_names": "noms des participants",
        "meeting_time": "heure de réunion",
        "timeline": "chronologie",
        "deliverables": "livrables",
        "project_goal": "objectif du projet",
        "project_scope": "périmètre du projet",
        "main_task": "tâche principale",
        "new_format": "nouveau format",
        "original_text": "texte original",
        "stakeholder_titles": "titres des parties prenantes",
        "article_title": "titre de l'article",
        "focus_keywords": "mots-clés de focus",
        "title_of_the_blog_text": "titre du texte de blog",
        "blog_topic": "sujet du blog",
        "section_title": "titre de section",
        "section_content": "contenu de section",
        "section": "section",
        "title": "titre",
        "title(faq_question)": "titre(question FAQ)",
        "issue_description": "description du problème",
        "code_section": "section de code",
        "concept": "concept",
        "version": "version",
        "changes": "changements",
        "job_title": "titre du poste",
        "your_name": "votre nom",
        "your_skills": "vos compétences",
        "math_question": "question de mathématiques",
        "question": "question",
        "thesis_topic": "sujet de thèse",
        "text_to_proofread": "texte à relire",
        "text_to_rephrase": "texte à reformuler",
        "text_to_improve": "texte à améliorer",
        "job_description": "description du poste",
        "your_title": "votre titre",
        "your_summary": "votre résumé",
        "pain": "douleur",
        "agitation": "agitation",
        "solution": "solution",
        "post_content": "contenu du post",
        "product_or_service": "produit ou service",
        "unique_selling_proposition": "proposition de vente unique",
        "audiences_objectives": "objectifs du public",
        "email_to_reply_to": "champ email de réponse",
        "sales_teams_roles": "rôles de l'équipe de vente"
    },
    "Auth": {
        "email": "Email",
        "password": "Mot de passe",
        "firstName": "Prénom",
        "lastName": "Nom de famille",
        "phoneNumber": "Numéro de téléphone",
        "login_descriptioon": "Découvrez ce qui se passe avec votre entreprise",
        "login_statement": "Connectez-vous à votre compte",
        "email_id": "Identifiant email",
        "Password": "Mot de passe",
        "Conform_pass": "Confirmer le mot de passe",
        "RememberMeL": "Se souvenir de moi",
        "Remember_password": "Se souvenir du mot de passe",
        "Forgot_Password": "Mot de passe oublié",
        "loading": "Chargement",
        "loging": "Connexion",
        "Register": "S'inscrire",
        "NotR": "Pas encore inscrit",
        "createAcc": "Créer un compte",
        "alredyacc": "Vous avez déjà un compte?",
        "ResendEmail": "Renvoyer l'email",
        "pleasecheck": "Veuillez vérifier votre email. Si vous ne l'avez pas reçu ou l'avez égaré, veuillez cliquer ci-dessous pour renvoyer l'email.",
        "backlogin": "Retour à la connexion",
        "Welcome_Msg": "Bienvenue chez BRAND_NAME",
        "Welcome_Description": "Accédez à des fonctionnalités exclusives en créant un compte",
        "agree": "J'accepte les",
        "tearm": "Conditions de service",
        "and": "et",
        "Privacy_Policy": "Politique de confidentialité",
        "forgatepasswordmsg": "Entrez l'email associé à votre compte et nous vous enverrons un email avec des instructions pour réinitialiser votre mot de passe.",
        "ltitle": "Travaillez sur de grandes idées, sans les tâches fastidieuses.",
        "time_format": "Format de l'heure",
        "timezone": "Fuseau horaire",
        "selectLanguage": "Sélectionner la langue",
        "check_credentials": "Veuillez vérifier vos informations d'identification.",
        "check_smtp_credentials": "Veuillez vérifier vos informations d'identification SMTP.",
        "smtp_successfully_verified": "Votre SMTP a été vérifié avec succès.",
        "verification_code_invalid": "Votre code de vérification est invalide.",
        "verification_code_invalid_check_code": "Votre code de vérification est invalide. Veuillez vérifier votre code.",
        "verification_mail_sent": "Le mail de vérification a été envoyé avec succès. Veuillez vérifier votre boîte de réception.",
        "no_account_found_for_email": "Aucun compte trouvé pour l'email fourni.",
        "verify_email_and_try_again": "Vérifiez votre email et réessayez.",
        "confirm_password": "Confirmer le mot de passe",
        "enter_new_password": "Veuillez entrer votre nouveau mot de passe",
        "link_expired_resend_email": "Votre lien a expiré.",
        "reset_password": "Réinitialiser le mot de passe",
        "resend_verification_email": "Veuillez cliquer sur le bouton pour renvoyer l'email de vérification",
        "link_expired": "Ce lien a expiré",
        "too_many_request": "Vous avez envoyé trop de demandes en un temps limité. Veuillez patienter et réessayer plus tard.",
        "previous_wasnot_valid": "Votre mot de passe précédent n'était pas valide. Veuillez vérifier et réessayer.",
        "password_wasnot_valid": "તમારું નવું પાસવર્ડ માન્ય ન હતું. કૃપા કરીને ફરી પ્રયાસ કરો.",
        "set_new_password": "Définir un nouveau mot de passe",
        "verification_link_expired": "Ce lien de vérification a expiré.",
        "verification_link_expired_message": "Veuillez vérifier votre boîte de réception pour le dernier e-mail de vérification. Si vous ne l'avez pas reçu, essayez de vous reconnecter pour en demander un nouveau.",
        "oAuthGoogleBtnText": "Continuer avec Google"
    },
    "Home": {
        "unlock": "Déverrouiller",
        "lock": "Verrouiller",
        "dashboardLockSuccess": "Tableau de bord verrouillé avec succès",
        "dashboardUnlockSuccess": "Tableau de bord déverrouillé avec succès",
        "Home": "Accueil",
        "My_Work": "Mon Travail",
        "Done": "Terminé",
        "To_Do": "À Faire",
        "no_task_found": "Aucune tâche trouvée",
        "Confirm": "Confirmer",
        "tourclose": "Êtes-vous sûr de vouloir fermer cette visite ? Si vous confirmez, vous ne pourrez plus accéder à ce guide.",
        "Queue_List": "Liste d'attente",
        "AddtoQueue": "Ajouter à la file d'attente",
        "noquelist": "Aucune liste d'attente trouvée",
        "Due_Date": "Date d'échéance",
        "createQueueTitle": "Créer une file d'attente",
        "Today": "Aujourd'hui",
        "Calendar": "Calendrier",
        "Hide": "Cacher",
        "Overdue": "En retard",
        "Next": "Suivant",
        "Unscheduled": "Non programmé",
        "task_assign_to_you": "tâche qui vous est assignée",
        "Notification_Request": "Demande de notification",
        "no": "Non",
        "yes": "Oui",
        "add_task_type": "Ajouter un type de tâche",
        "are_you_sure": "Voulez-vous activer les notifications du navigateur ?"
    },
    "Header": {
        "Project_Forecasting": "Prévision du projet (Bientôt disponible)",
        "Resource_Planning": "Planification des ressources (Bientôt disponible)",
        "Projects": "Projets",
        "Time_Sheet": "Feuille de temps",
        "User_Timesheet": "Feuille de temps utilisateur",
        "project_Timesheet": "Feuille de temps projet",
        "Workload_Timesheet": "Feuille de temps de charge de travail",
        "Tracker_Timesheet": "Feuille de temps de suivi",
        "Reports": "Rapports",
        "Milestone_Report": "Rapport de jalon",
        "Time_Forcasting": "Prévision du temps",
        "Chat": "Chat",
        "Notification": "Notification",
        "mention": "Mention",
        "Tours": "Visites",
        "Logout": "Déconnexion",
        "Mark_all_as_read": "Tout marquer comme lu",
        "Mark_all_as_complete": "Tout marquer comme terminé",
        "designation": "Désignation",
        "upgrade_now": "Mettre à jour maintenant",
        "load_more": "Charger plus",
        "take_tour": "Faire une visite",
        "task_details": "Détails de la tâche",
        "Comments": "Commentaires",
        "activity_log": "Journal d'activité",
        "time_log": "Journal de temps",
        "mentions": "Mentions",
        "Notifications": "Notifications",
        "no_data_found": "Aucune donnée trouvée",
        "search_results": "Résultats de recherche",
        "my_profile": "Mon Profil",
        "billing_history": "Historique de facturation",
        "Assignee": "Attribué à",
        "Due Date": "Date d'échéance",
        "Priority": "Priorité",
        "Key": "Clé",
        "Created Date": "Date de création",
        "Created By": "Créé par",
        "advance_search": "Recherche avancée",
        "for_advance_search": "Pour une recherche avancée",
        "get_more": "En obtenir plus ?",
        "to_unlock_activity_view": "Pour débloquer la vue d'activité",
        "AssigneeUserId": "Assigné",
        "DueDate": "Date d'échéance",
        "TaskKey": "Clé",
        "Task_Priority": "Priorité",
        "commentCounts": "Chat",
        "created_by": "Créé par",
        "created_date": "Date de création",
        "create_project": "Créer un projet",
        "Company": "Entreprise"
    },
    "ProjectDetails": {
        "select_project_category": "Sélectionner la catégorie de projet",
        "select_currency": "Sélectionner la devise",
        "description": "Description",
        "details": "Détails",
        "status": "Statut",
        "assignee": "Attribué à",
        "key": "Clé",
        "category": "Catégorie",
        "source": "Source",
        "type": "Type",
        "billing_period": "Période de facturation",
        "currency": "Devise",
        "amount": "Montant",
        "start_date": "Date de début",
        "end_date": "Date de fin",
        "no_start_date": "Pas de date de début",
        "no_end_date": "Pas de date de fin",
        "no_due_date": "Pas de date d'échéance",
        "msg": "La date de début ne peut pas être modifiée car elle est déjà",
        "msgbr": "dans une plage de jalons.",
        "startdatemsg0": "La date de début ne peut pas être modifiée car elle est déjà",
        "startdatemsg1": "dans une plage de jalons.",
        "ok": "ok",
        "lead": "Responsable",
        "browse_by_category": "Parcourir par catégorie",
        "subtask": "Sous-tâche",
        "details_project_setup": "Détails de la configuration du projet",
        "avatar": "Avatar",
        "shared_with": "Partagé avec",
        "no_user_selected": "Aucun utilisateur sélectionné",
        "required_view": "Vues requises",
        "set_the_require": "Définissez les vues requises. Ces vues seront automatiquement créées lorsque vous naviguez vers Projets, Dossiers et Listes dans BRAND_NAME au lieu de les créer manuellement. Une fois créées, les vues ne peuvent pas être supprimées.",
        "always_required": "Toujours requis",
        "make_default": "Définir par défaut",
        "reporter": "Rapporteur",
        "copy_task_link": "Copier le lien de la tâche",
        "copy_task_key": "Copier la clé de la tâche",
        "add_que_list": "Ajouter à la liste de queue",
        "remove_que_list": "Retirer de la liste de queue",
        "convert_list": "Convertir en liste",
        "convert_subtask": "Convertir en sous-tâche",
        "merge": "Fusionner",
        "move": "Déplacer",
        "convert_task": "Convertir en tâche",
        "no_currency_found": "Aucune devise trouvée",
        "remove_from_queue_list": "Retirer de la liste de queue",
        "CONVERT_AND_OPEN": "Convertir et Ouvrir",
        "DUPLICATE_AND_OPEN": "Dupliquer et Ouvrir",
        "MERGE_AND_OPEN": "Fusionner et Ouvrir",
        "MOVE_AND_OPEN": "Déplacer et Ouvrir",
        "convert": "Convertir"
    },
    "ProjectSlider": {
        "new_project": "Nouveau Projet",
        "no_archived": "Aucune donnée archivée trouvée",
        "you_dont": "Vous n'avez aucun projet",
        "archived_list": "Liste archivée",
        "projects": "Projets",
        "project_name": "Nom du projet",
        "folder_name": "Nom du dossier",
        "sprint_name": "Nom du sprint",
        "show_archive": "Afficher l'archive",
        "hide_archive": "Masquer l'archive",
        "try_using_diff": "Essayez d'utiliser des mots-clés différents",
        "no_project_found": "Aucun projet trouvé",
        "no_result_found": "Aucun résultat trouvé",
        "select_project_status": "Sélectionner le statut du projet",
        "no_activity_log_found": "Aucun journal d'activité trouvé",
        "task_planning": "Planification des tâches"
    },
    "Projects": {
        "sprint": "Sprint",
        "folder": "Dossier",
        "task_view": "Vue des tâches",
        "default_view": "Vue par défaut",
        "add_view": "Ajouter une vue",
        "rename": "Renommer",
        "pin": "Épingler",
        "edit_code": "Modifier le code",
        "copy_link": "Copier le lien",
        "delete": "Supprimer",
        "view": "Vue",
        "watchers": "Observateurs",
        "files_links": "Fichiers & Liens",
        "audio_files": "Fichiers audio",
        "project_permissions": "Permissions de projet",
        "color_avatar": "Couleur & Avatar",
        "duplicate": "Dupliquer",
        "close_project": "Fermer le projet",
        "archive": "Archiver",
        "search_in": "Rechercher dans",
        "expanded": "Développé",
        "collapsed": "Réduit",
        "me": "Moi",
        "status": "Statut",
        "priority": "Priorité",
        "due_date": "Date d'échéance",
        "group_by": "Grouper par",
        "subtask": "Sous-tâche",
        "task_name": "Nom de la tâche",
        "task_key": "Clé de tâche",
        "everyone": "Tout le monde",
        "private": "Privé",
        "share_with": "Partager avec",
        "create_new_list": "Créer un nouveau sprint",
        "create_new_folder": "Créer un nouveau dossier",
        "restore": "Restaurer",
        "unpin": "Détacher la vue",
        "pinview": "Épingler la vue",
        "deleteview": "Supprimer la vue",
        "close": "Fermer",
        "cancel": "Annuler",
        "tasks": "Tâches",
        "save": "Enregistrer",
        "create_project": "Créer un projet",
        "use_template": "Utiliser un modèle",
        "blank_project": "Projet vierge",
        "no_category_found": "Aucune catégorie trouvée",
        "template": "Modèle",
        "save_create": "Enregistrer & Créer",
        "save_tamplete": "Enregistrer en tant que modèle",
        "previous": "Précédent",
        "new_task": "Nouvelle tâche",
        "add_subtask": "Ajouter une sous-tâche",
        "list_of_user": "Liste des utilisateurs",
        "list_of_project_status": "Liste des statuts de projet",
        "list_of_task_type": "Liste des types de tâche",
        "list_of_task_status": "Liste des statuts de tâche",
        "list_cc": "Liste cc",
        "category_list": "Liste des catégories",
        "created_by": "Créé par",
        "tags": "Étiquettes",
        "task_type": "Type de tâche",
        "workspace": "Espace de travail",
        "project_color": "Couleur du projet",
        "search": "Rechercher",
        "add_task_need": "Ajoutez le type de tâches dont vous avez besoin",
        "what_task_want": "Quel type de tâche voulez-vous",
        "no_sub_tasks_found": "Aucune sous-tâche trouvée",
        "all_project": "Tous les projets",
        "closed_project": "Projet fermé",
        "go_to_project": "Aller aux projets",
        "reopen_project": "Rouvrir le projet",
        "required_view": "Vues requises",
        "project_status": "Ajoutez les statuts pour le projet",
        "what_project": "Quel statut de projet voulez-vous",
        "active_status": "Statut actif",
        "done_status": "Statut terminé",
        "add_status": "Ajouter un statut",
        "close_status": "Statut fermé",
        "submit": "Soumettre",
        "Audio_Files": "Fichiers audio",
        "Files & Links": "Fichiers & Liens",
        "no_audio_file": "Aucun fichier audio trouvé",
        "change_color": "Changer la couleur & l'avatar",
        "files": "Fichiers",
        "links": "Liens",
        "about": "À propos",
        "result": "résultats",
        "seconds": "secondes",
        "sort_by": "Trier par",
        "relevance": "Pertinence",
        "last_update": "Dernière mise à jour",
        "last_created": "Dernière création",
        "issue": "Problème",
        "update": "Mettre à jour",
        "date": "Date",
        "time": "Heure",
        "duration": "Durée",
        "duplicate_task": "Dupliquer la tâche",
        "browse_projects": "Parcourir les projets",
        "location": "Emplacement",
        "add_new": "Ajouter nouveau",
        "create_compnay": "Créer une entreprise",
        "company_name": "Nom de l'entreprise",
        "archived_project": "Projet archivé",
        "assignee_teams": "Équipes assignées",
        "assignee_user": "Utilisateurs assignés",
        "all": "Tous",
        "restore_project": "Restaurer le projet",
        "delete_project": "Supprimer le projet",
        "items_per_page": "Articles par page",
        "Assignee": "Responsable",
        "Project_Created_Date": "Date de Création du Projet",
        "Project_Status": "Statut du Projet",
        "Project_Type": "Type de Projet",
        "Comments_Counts": "Nombre de Commentaires",
        "Created_Date": "Date de Création",
        "Name": "Nom",
        "Running_Time_Tracker": "Suivi du Temps en Cours",
        "results_in_time": "Résultats en",
        "Assigned_to": "Attribué à",
        "Project": "Projet",
        "Currency": "Devise",
        "Milestone_Type": "Type de Jalons",
        "Project_Category": "Catégorie de Projet",
        "Comment_Type": "Type de Commentaire",
        "projects": "projets",
        "create_blank_project": "Créer un projet vierge",
        "create_project_using_template": "Créer un projet en utilisant un modèle",
        "choose_apps": "Choisissez des applications"
    },
    "Watcher": {
        "ignore": "Ignorer",
        "participating_mentions": "Mentions et participations",
        "list_of_watcher": "Liste des observateurs",
        "all_activity": "Toutes les activités",
        "watchers_list": "Liste des observateurs",
        "owner": "Propriétaire"
    },
    "ViewList": {
        "List": "Liste",
        "Board": "Tableau",
        "Project Details": "Détails du projet",
        "Comments": "Commentaires",
        "Calendar": "Calendrier",
        "Activity": "Activité",
        "Workload": "Charge de travail",
        "Gantt": "Gantt",
        "Table": "Table",
        "Timeline": "Chronologie",
        "Embed": "Intégrer",
        "Comment": "Commentaire",
        "to_unlock_list_view": "Pour débloquer la vue en liste",
        "error_message_for_empty": "Veuillez sélectionner au moins une vue",
        "set_as_default": "Définir par défaut",
        "remove_as_default": "Supprimer comme défaut"
    },
    "Apps": {
        "tags": "Étiquettes",
        "Priority": "Priorité",
        "TimeEstimates": "Estimations de temps",
        "Milestones": "Étapes importantes",
        "MultipleAssignees": "Assignations multiples",
        "CustomFields": "Champs personnalisés",
        "TimeTracking": "Suivi du temps",
        "AI": "IA"
    },
    "Tags": {
        "no_tags_found": "Aucune étiquette trouvée",
        "search_or_create_new": "Rechercher ou créer une nouvelle",
        "change_color": "Changer la couleur",
        "delete_tag": "Supprimer l'étiquette",
        "delete_tag_desc": "Êtes-vous sûr de vouloir supprimer l'étiquette partout dans cet espace ?",
        "note_msg": "Appuyez sur Entrée pour créer un nouveau tag",
        "Tag_name_required": "Nom du tag requis",
        "This_tag_has_already_been_added": "Ce tag a déjà été ajouté"
    },
    "Embeded": {
        "Anything": "Quelque chose",
        "Sheets": "Google Sheets",
        "Docs": "Google Docs",
        "Youtube": "Youtube",
        "Figma": "Figma",
        "The_name_is_required": "Le nom est requis",
        "Please_enter_valid_url": "Veuillez entrer une URL valide",
        "The_Html_code_is_required": "Le code HTML est requis",
        "The_name_should_be_at_least_3_characters_long": "Le nom doit comporter au moins 3 caractères",
        "The_url_is_required": "L'URL est requise",
        "URL_already_exists": "L'URL existe déjà",
        "name_already_exists": "Ce nom existe déjà",
        "to_unlock_embed_view": "Pour débloquer la vue intégrée"
    },
    "ViewListdescription": {
        "list_view": "Utilisez la vue Liste pour organiser vos tâches de toutes les manières imaginables - trier, filtrer, regrouper et personnaliser les colonnes.",
        "kanban_view": "Construisez votre tableau parfait et déplacez facilement les tâches entre les colonnes.",
        "projectdetail_view": "Ajoutez les exigences initiales, la liste de contrôle et les pièces jointes pour que votre équipe comprenne en détail.",
        "Comments_view": "Ajoutez des commentaires en temps réel sur n'importe quel sujet avec votre équipe afin qu'ils soient notifiés et puissent répondre.",
        "calender_view": "La vue Calendrier est votre espace pour la planification, l'ordonnancement et la gestion des ressources.",
        "table_view": "Gérez, mettez à jour et organisez facilement vos tâches avec la vue Tableau.",
        "workload_view": "Consultez la capacité de votre équipe, qui est surchargé ou sous-chargé, et réaffectez les tâches en conséquence.",
        "activitylog_view": "Obtenez une vue agrégée de toutes les activités dans un emplacement. Filtrez par personnes et par type pour obtenir une vue détaillée de l'activité que vous voyez.",
        "add_msg1": "Ajoutez des applications et des sites Web à côté de vos tâches avec la vue Intégrer pour gagner du temps et réduire les interruptions.",
        "add_msg2": "pour gagner du temps et réduire les interruptions.",
        "view_name": "Nom de la vue",
        "embed_URL": "URL d'intégration",
        "embed_HTML": "Code HTML d'intégration",
        "private_view": "Vue privée"
    },
    "Filters": {
        "filter": "Filtres",
        "learnmorefilter": "En savoir plus sur les filtres",
        "pleaseselectvalid": "Veuillez sélectionner toutes les options valides",
        "confirm": "Confirmer",
        "are_you_sure": "Êtes-vous sûr de vouloir supprimer",
        "clearall": "Effacer tout",
        "addfilter": "Ajouter un filtre",
        "where": "Où",
        "filtering_field": "Champ de filtrage",
        "no_date_found": "Aucune date trouvée",
        "save_this_filters": "Enregistrer ces filtres",
        "save_filter": "Enregistrer le filtre",
        "save": "Enregistrer",
        "update_filter": "Mettre à jour le filtre",
        "my_filter": "Mon filtre",
        "no_data_found": "Aucune donnée trouvée",
        "show_result": "Afficher le résultat",
        "save_filters": "Enregistrer les filtres",
        "filter_by": "Filtrer par",
        "projects": "Projets",
        "teams": "Équipes",
        "user": "Utilisateur",
        "no_comment_found": "Aucun commentaire trouvé",
        "no_project_found": "Aucun projet trouvé",
        "no_file_found": "Aucun fichier trouvé",
        "no_link_found": "Aucun lien trouvé",
        "filter_operator": "Opérateur de filtre",
        "options": "Possibilités",
        "priorities": "Priorités",
        "select_all": "Sélectionner tout",
        "milestone_type": "Type d'étape",
        "comment_type": "Type de commentaire",
        "a_to_z": "A à Z",
        "no_files_found": "Aucun fichier trouvé",
        "no_links_found": "Aucun lien trouvé",
        "no_links_or_files_found": "Aucun lien ou fichier trouvé",
        "z_to_a": "Z à A",
        "are_you_suredelete": "Etes-vous sûr de vouloir supprimer",
        "sort_by": "Trier Par",
        "A-Z": "A-Z",
        "Ascending": "Croissant",
        "Descending": "Décroissant",
        "No": "Non",
        "Yes": "Oui",
        "Z-A": "Z-A",
        "Save_this_Filter": "Enregistrer ce Filtre",
        "Enter_Filter_Name": "Saisissez le Nom du Filtre",
        "Select_Options": "Sélectionner les Options",
        "Equal_To": "Égal À",
        "Greater_Than": "Plus Grand Que",
        "Is": "Est",
        "Less_Than": "Moins Que",
        "Clear_All": "Tout Effacer",
        "select_assignee": "Sélectionnez un assigné",
        "select_project_types": "Sélectionnez les types de projet",
        "unselect_all": "Désélectionner tout",
        "Not_Equals_To": "N'est pas"
    },
    "conformationmsg": {
        "archive": "Une liste peut être archivée pour la masquer de la vue, mais elle peut être restaurée à tout moment. Toutes les tâches sont conservées et restent consultables lorsque vous archivez une liste.",
        "delete": "Les tâches et modèles de ce projet seront tous effacés. Tapez le nom du projet pour confirmer que vous souhaitez vraiment supprimer toutes les tâches, les modèles et ce projet.",
        "archive0mesg": "Tapez le nom du projet pour confirmer que vous souhaitez vraiment fermer ce projet",
        "sprintclosemsg": "Tapez le nom du sprint pour confirmer que vous souhaitez vraiment fermer ce sprint",
        "type": "Type",
        "are_you_sure": "Êtes-vous sûr ?",
        "no_revert_msg": "Vous ne pourrez pas revenir en arrière !",
        "yes_delete": "Oui, supprimez-le !",
        "task_will_become_subtasks_of": "La tâche deviendra des sous-tâches de",
        "Are_you_sure_you_want_to_delete": "Êtes-vous sûr de vouloir supprimer",
        "subtasks_will_become_subtasks_of": "Les sous-tâches deviendront des sous-tâches de",
        "unlock_board_view": "Pour déverrouiller la vue tableau",
        "unlock_calendar_view": "Pour déverrouiller la vue calendrier",
        "unlock_project_detail_view": "Pour déverrouiller la vue des détails du projet",
        "unlock_table_view": "Pour déverrouiller la vue en tableau",
        "unlock_workload_view": "Pour déverrouiller la vue de la charge de travail",
        "to_unlock_tracker_timesheet": "Pour débloquer la feuille de temps du traqueur",
        "to_unlock_user_timesheet": "Pour débloquer la feuille de temps de l'utilisateur"
    },
    "Description": {
        "description": "Description",
        "edit": "Modifier",
        "add_description": "Ajouter une description",
        "show_less": "Afficher moins",
        "show_more": "Afficher plus",
        "description_placeholder": "Écrivez quelque chose ou tapez '/' pour les commandes et l'action de l'IA",
        "saved": "Enregistré"
    },
    "Checklist": {
        "checklist": "Liste de contrôle",
        "add_checklist": "Ajouter une liste de contrôle",
        "suggest_checklists": "Suggérer des listes de contrôle",
        "Checklists": "Listes de vérification",
        "to_unlock_checklist": "Pour débloquer la liste de vérification"
    },
    "Attachments": {
        "attachments": "Pièces jointes",
        "drag_file": "Vous pouvez également faire glisser et déposer des fichiers ici.",
        "see_all": "Voir tout",
        "drop_file": "Déposez des fichiers ici pour attacher ou",
        "browse": "Parcourir",
        "no_preview_found": "Aucun aperçu trouvé",
        "show_all_pages": "Afficher toutes les pages",
        "drop_here": "Déposez ici"
    },
    "Milestone": {
        "milestone": "Étape importante",
        "milestone_name": "Nom de l'étape",
        "status_date": "Date du statut",
        "total_amount": "Montant total",
        "are_you_sure": "Êtes-vous sûr de vouloir supprimer l'étape importante",
        "add_new": "Ajouter une nouvelle",
        "mileston_status": "Statut de l'étape importante",
        "project_name": "Nom du projet",
        "end_date": "Date de fin",
        "start_date": "Date de début",
        "estimated_release": "Liberation estimée",
        "release_request_sent": "Demande de libération envoyée",
        "released": "Libéré",
        "not_funded": "Non financé",
        "funded": "Financé",
        "project_milestone_Status": "Statut de l'étape du projet",
        "milestone_status_name": "Nom du statut de l'étape",
        "date_displaye": "Date affichée dans le calendrier",
        "past": "Passé",
        "feature": "l'avenir",
        "milestone_weekly_range": "Plage hebdomadaire des étapes importantes",
        "file_extensions": "Extensions de fichier",
        "avatar": "Avatar",
        "adding_estimated": "Ajouter des heures estimées",
        "range": "Plage",
        "user": "Utilisateur",
        "refunded_amount": "Montant remboursé",
        "Name_already_exists": "Le champ du statut de jalon est requis",
        "The_milestone_status_field_is_required": "Le champ du statut de jalon est requis",
        "The_milestone_status_field_must_be_at_leat_characters": "Le champ du statut de jalon doit comporter au moins 3 caractères",
        "Max_2_decimal_places_allowed": "Maximum de 2 décimales autorisé",
        "actual_amount": "Montant réel",
        "partially_refunded": "Partiellement remboursé",
        "refunded_amount_should_not_exceed_amount": "Le montant du remboursement ne doit pas dépasser le montant",
        "total_partially_refunded": "Total partiellement remboursé",
        "field_should_not_be_smaller_than_refund_amount": "Le champ ne doit pas être inférieur au montant du remboursement",
        "The_hours_field_is_required": "The hours field is required",
        "The_minute_field_must_be_59_or_less": "The minute field must be 59 or less",
        "white_color_not_allowed": "La couleur blanche n'est pas autorisée. Veuillez sélectionner une couleur valide",
        "billing": "Facturation",
        "per_hour": "Par heure",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "Le champ du montant ne doit pas être inférieur au montant remboursé.",
        "The_refunded_amount_field_should_not_be_more_then_amount": "Le champ du montant remboursé ne doit pas dépasser le montant.",
        "adding_taskPlanning": "Ajouter la planification des tâches"
    },
    "Comment": {
        "created_by": "Créé par",
        "created_on": "Créé le",
        "task_name": "Nom de la tâche"
    },
    "UserTimesheet": {
        "back_projects": "Retour aux projets",
        "user_timesheet": "Feuille de temps de l'utilisateur",
        "back": "Retour",
        "tracked_time": "Temps suivi",
        "manual_time": "Temps manuel",
        "users": "Utilisateurs",
        "logged": "Connecté",
        "hours": "Heures",
        "estimated": "Estimé",
        "no_records_found": "Aucun enregistrement trouvé",
        "project_timesheet": "Feuille de temps du projet",
        "tracker_timesheet": "Feuille de temps du suivi",
        "workload_timesheet": "Feuille de temps de la charge de travail",
        "milestone_reports": "Rapports d'étape",
        "add_time": "Ajouter du temps",
        "add_time_log": "Ajouter un journal de temps",
        "edit_time_log": "Modifier le journal de temps",
        "Teams": "Équipes",
        "Users": "Utilisateurs",
        "Projects": "Projets",
        "task_remaining_planning": "Heures restantes",
        "task_planning": "planification des tâches",
        "planned": "Planifié"
    },
    "ProjectWorkplace": {
        "msg1": "Les projets peuvent être partagés avec des membres. Vous pouvez ajouter des invités aux dossiers, listes et tâches après avoir créé un projet.",
        "msg2": "Actuellement, il n'y a aucun plan en place pour créer des projets privés ou publics. Si vous souhaitez initier un projet, la mise à niveau de votre plan serait nécessaire."
    },
    "CustomField": {
        "custom_field": "Champ personnalisé",
        "create_custom_field": "Créer un champ personnalisé",
        "lable": "Étiquette",
        "action": "Action",
        "add_custom_field": "Ajouter un champ personnalisé",
        "add_new_custom_field": "Ajouter un nouveau champ personnalisé",
        "field_name": "Nom du champ",
        "date_created": "Date de création",
        "add_another_item": "Ajouter un autre élément",
        "choose_ready_made_list": "Choisissez une liste d'options préétablie (par exemple, jours, mois, etc.)",
        "predefined_options": "Options prédéfinies",
        "selected_by_default": "Sélectionné par défaut",
        "allow_time_with_date": "Permettre aux utilisateurs de spécifier une heure avec la date.",
        "date_format": "Format de date",
        "days_of_week": "Jours de la semaine",
        "past_and_future": "Passé et Futur",
        "select_date_format": "Sélectionnez un format de date. D représente le jour, M le mois et Y l'année.",
        "select_dates_past_future": "Permettre aux utilisateurs de sélectionner des dates dans le passé ou le futur",
        "select_time_format": "Sélectionnez un format d'heure",
        "time_format": "Format de l'heure",
        "unchecking_day_calendar": "Désélectionner un jour le rendra indisponible dans le calendrier",
        "future": "Futur",
        "past": "Passé",
        "enter_maximum_limit": "Entrez la limite maximale",
        "enter_minimum_limit": "Entrez la limite minimale",
        "limit_minimum_or_maximum_value": "Limitez la valeur minimale ou maximale autorisée pour ce champ",
        "maximum_limit_type_not_allowed_value": "La valeur saisie pour le type de limite maximale n'est pas une valeur autorisée.",
        "maximum_value_should_be_greater_than_minimum_value": "La valeur maximale doit être supérieure à la valeur minimale",
        "minimum_limit_type_not_allowed_value": "La valeur saisie pour le type de limite minimale n'est pas une valeur autorisée.",
        "minimum_value_should_not_be_greater_than_maximum_value": "La valeur minimale ne doit pas être supérieure à la valeur maximale",
        "no_country_found": "Aucun pays trouvé",
        "enter_maximum_limit_type": "Entrez le type de limite maximale",
        "enter_minimum_limit_type": "Entrez le type de limite minimale",
        "limit_minimum_or_maximum_text_allowed": "Limitez le nombre minimum ou maximum de texte autorisé dans ce champ",
        "max_should_be_greater_than_min": "Le maximum doit être supérieur au minimum",
        "min_should_be_less_than_max": "Le minimum doit être inférieur au maximum",
        "separator": "Séparatrice",
        "countryCode": "Activez-le pour modifier le code du pays."
    },
    "Category": {
        "cateory_name": "Nom de la catégorie",
        "create_category": "Créer une catégorie",
        "upgradeplanemsg": "Pour accéder à cette fonctionnalité, veuillez mettre à niveau votre plan.",
        "create_channel": "Créer un canal",
        "no_chat_found": "Aucun chat trouvé"
    },
    "Channel": {
        "create_channel": "Créer un canal",
        "msg1": "Vous avez atteint la limite maximale de création de canaux publics et privés. Pour accéder à cette fonctionnalité, veuillez mettre à niveau votre plan.",
        "channel_name": "Nom du canal",
        "icons": "Icônes",
        "or": "ou",
        "only_share_with": "Partager uniquement avec",
        "private_channel": "Canal privé",
        "msg2": "Seuls les membres et rôles sélectionnés pourront voir ce canal",
        "allowmsg2": "Permet aux membres d'envoyer des messages dans ce canal",
        "send_messages": "Envoyer des messages",
        "choose_to_upload": "Choisissez une image à télécharger",
        "private_channel_limit_reached": "Vous avez atteint la limite de création de canaux privés. Vous pouvez uniquement créer des canaux publics. Si vous souhaitez créer un canal privé, veuillez mettre à niveau votre plan.",
        "public_channel_limit_reached": "Vous avez atteint la limite de création de canaux publics. Vous pouvez uniquement créer des canaux privés. Si vous souhaitez créer un canal public, veuillez mettre à niveau votre plan."
    },
    "Templates": {
        "delete_template": "Supprimer le modèle",
        "project_status": "Statut du projet",
        "task_status": "Statut de la tâche",
        "no_app_selected": "Aucune application sélectionnée",
        "default_views": "Paramètre par défaut pour les vues",
        "apps": "Applications",
        "add_new_templete": "Ajouter un nouveau modèle",
        "templates": "Modèles",
        "s": "s",
        "template_name": "Nom du modèle",
        "upload_image": "Télécharger une image",
        "all_good": "Tout va bien",
        "create_template": "Créer un modèle",
        "new_template": "Nouveau modèle",
        "remove": "Supprimer",
        "enable_apps": "Activer les applications",
        "Turn": "Tourner",
        "all_apps": "Toutes les applications",
        "off": "désactivé",
        "on": "activé",
        "upload": "Télécharger",
        "save_template": "Enregistrer le modèle",
        "setup_status": "Configurer les statuts des tâches",
        "what_task": "Quel statut de tâche voulez-vous",
        "select_task_status": "Sélectionner le statut de la tâche",
        "delete_template_confirmation": "Êtes-vous sûr de vouloir supprimer le modèle ?",
        "ai_sidebar_title": "Créer un modèle avec l'IA",
        "ai_label_category": "Catégorie",
        "ai_label_description": "Description",
        "ai_button_text_requested_changes": "Demander des modifications",
        "ai_min_view_msg_text": "Au moins une vue requise",
        "ai_min_msg_text": "Au minimum 10 caractères requis",
        "ai_before_desc_placeholder": "Entrez une description du cas d'utilisation pour générer un modèle",
        "ai_after_desc_placeholder": "Vous pouvez continuer à poser des questions pour des modifications pertinentes ici",
        "try_with_ai": "Essayer avec l'IA",
        "msg_search_result_found": "Voici quelques modèles suggérés correspondant à vos besoins. Vous pouvez en sélectionner un ou cliquer simplement pour en créer un avec l'IA",
        "msg_search_result_not_found": "Aucun modèle pertinent trouvé. Pour en créer un avec l'IA, cliquez simplement"
    },
    "Settings": {
        "add_new_projects": "Ajouter un nouveau projet",
        "task_priority": "Priorité de la tâche",
        "maximum_image_size": "Taille d'image maximale",
        "warning": "Avertissement",
        "cant_delete": "ne peut pas être supprimé",
        "priority_in_use": "L'utilisateur ne peut pas supprimer la priorité PRIORITY_NAME car elle est déjà utilisée.",
        "company_name": "Nom de l'entreprise",
        "phone": "Téléphone",
        "country": "Pays",
        "state": "État",
        "city": "Ville",
        "select_date_format": "Sélectionner le format de date",
        "save_changes": "Enregistrer les modifications",
        "currencies": "Devises",
        "add_remove_cur": "Ajouter/Supprimer des devises",
        "change_image": "Changer d'image",
        "Priorities_already_Exists": "Les priorités existent déjà",
        "The_priority_image_field_is_required": "Le champ de l'image de la priorité est requis",
        "The_priority_name_field_is_required": "Le champ du nom de la priorité est requis",
        "The_priority_name_field_must_be_at_least": "Le champ du nom de la priorité doit comporter au moins 3 caractères",
        "The_file_extension_field_is_required": "Le champ de l'extension de fichier est requis",
        "The_file_extension_field_must_be_at_least": "Le champ de l'extension de fichier doit comporter au moins 3 caractères",
        "file_extension_is_not_supported": "L'extension de fichier n'est pas prise en charge",
        "file_extension_already_Exists": "L'extension de fichier existe déjà"
    },
    "Members": {
        "invite": "Inviter",
        "all_members": "Tous les membres",
        "removed_members": "Membres supprimés",
        "name": "Nom",
        "role": "Rôle",
        "last_active": "Dernière activité",
        "time_tracker": "Suivi du temps",
        "settings": "Paramètres",
        "removeuser": "Supprimer l'utilisateur",
        "adduser": "Ajouter un utilisateur",
        "invite_user": "Inviter un utilisateur",
        "remove_request": "Supprimer la demande",
        "resend_invitation": "Renvoyer l'invitation",
        "cancel_invitation": "Annuler l'invitation",
        "Invitation_mail_sent_sucessfully": "E-mail d'invitation envoyé avec succès",
        "confirm_change_user_designation": "Êtes-vous sûr de vouloir changer le titre de ce utilisateur en",
        "confirm_change_user_role": "Êtes-vous sûr de vouloir changer le rôle de ce utilisateur en",
        "Import_users_from_csv": "Importer des utilisateurs depuis un fichier CSV"
    },
    "Upgrades": {
        "take_next_step": "Faites le prochain pas avec votre travail",
        "you_are_on": "Vous êtes actuellement sur le",
        "per_year": "Par an",
        "per_month": "Par mois",
        "current_plane": "Plan actuel",
        "per_member": "Par membre",
        "and_much_more": "et beaucoup plus",
        "upgrade_to": "Passer à",
        "select_payment_method": "Sélectionnez le mode de paiement",
        "plan": "Plan",
        "plane_upgrade": "Mise à niveau du plan réussie",
        "plane_upgrade_msg": "Mise à niveau du plan réussie ! Votre abonnement a été mis à niveau. Veuillez attendre 2 à 3 minutes pour que les modifications prennent effet partout, afin de vous permettre de profiter pleinement des fonctionnalités et améliorations étendues !",
        "something_wrong": "Quelque chose a mal tourné. Veuillez réessayer",
        "unsucessfull_msg": "Échec de la mise à niveau du plan. Nous avons rencontré un problème lors de la mise à niveau de votre plan. Veuillez réessayer ou contacter le support pour obtenir de l'aide.",
        "upgrade_your_plan": "Améliorez votre plan",
        "to_unlock_custom_field": "Pour débloquer le champ personnalisé",
        "unlimited": "Illimité",
        "the_feature_not_available": "Cette fonctionnalité n'est pas disponible avec votre plan actuel",
        "unlock_project_permission": "Pour débloquer les autorisations de projet",
        "unlock_custom_field": "Pour débloquer le champ personnalisé",
        "to_unlock_milestone": "Pour débloquer le jalon",
        "to_unlock_milestone_report": "Pour débloquer le rapport de jalon",
        "to_unlock_security": "Pour débloquer la sécurité et les autorisations",
        "to_unlock_team": "Déverrouiller l'équipe",
        "to_unlcok_project": "Pour débloquer le projet",
        "You_have_reached_the_free_plan_limit": "Vous avez atteint la limite de PLAN_NAME",
        "require_upgrade_message": "Vous pouvez créer jusqu'à PROJECT_COUNT projets sur le plan PROJECT_NAME. Créez plus de tableaux en mettant à niveau votre plan.",
        "are_you_sure_you_want_to_update": "Êtes-vous sûr de vouloir mettre à jour ?",
        "find_out_whats_included_in_this_update": "Découvrez ce qui est inclus dans cette mise à jour",
        "improved_performance": "Performance améliorée",
        "install_now": "Installer maintenant",
        "later": "Plus tard",
        "please_see_below_for_a_list_of_changes_to_the_features": "Veuillez consulter ci-dessous la liste des changements apportés aux fonctionnalités.",
        "to_integrate_new_services_into_an_alian_hub": "Pour intégrer de nouveaux services dans Hyphen OI Pro.",
        "whats_new": "Quoi de neuf ?",
        "check_to_agree_with_above_points": "Cochez pour accepter les points ci-dessus",
        "general_notes": "Notes générales",
        "update_now": "Mettre à jour maintenant",
        "unlock_channel": "Pour déverrouiller le canal",
        "unlock_chat": "Pour déverrouiller le chat",
        "unlock_one_chat": "Pour déverrouiller le chat en tête-à-tête",
        "public_private_creation_time_limit_reached": "Vous avez atteint la limite de création de projets. Si vous souhaitez créer un projet, veuillez mettre à niveau votre plan.",
        "public_creation_time_limit_reached": "Vous avez atteint la limite de création de projets publics. Vous ne pouvez créer que des projets privés. Si vous souhaitez créer un projet public, veuillez mettre à niveau votre plan.",
        "private_creation_time_limit_reached": "Vous avez atteint la limite de création de projets privés. Vous ne pouvez créer que des projets publics. Si vous souhaitez créer un projet privé, veuillez mettre à niveau votre plan."
    },
    "Permissions": {
        "advanced_permission": "Autorisations avancées",
        "allow_admins": "Autoriser les administrateurs à gérer des Espaces privés",
        "when_admin_enable": "Lorsqu'il est activé, les administrateurs pourront ajouter/enlever des personnes et transférer la propriété de tous les Espaces.",
        "show_all_projects": "Afficher tous les projets",
        "when_user_enable": "Lorsqu'il est activé, les utilisateurs pourront voir tous les projets globaux.",
        "show_all_task": "Afficher toutes les tâches",
        "when_user_enable_sprint": "Lorsqu'il est activé, les utilisateurs pourront voir toutes les tâches dans les sprints.",
        "own": "Propre",
        "select": "Sélectionner",
        "Member": "Membre",
        "Guest": "Invité",
        "None": "Aucun",
        "Read": "Lire",
        "add_new_team": "Ajouter une nouvelle équipe",
        "Read & Write": "Lire & Écrire",
        "Support": "Support",
        "select_priorities": "Sélectionner les priorités",
        "apply_permission": "Appliquer l'autorisation",
        "project_permission_description": "Pour remplacer les autorisations globales, cela est désactivé par défaut. Une fois activé, vous pouvez gérer les autorisations de projet et de tâche. S'il est désactivé, les autorisations globales sont alors appliquées.",
        "project_permission_title_disable": "La possibilité d'accorder des autorisations personnalisées pour ce projet sera désactivée",
        "project_permission_title_enable": "La possibilité d'accorder des autorisations personnalisées pour ce projet sera activée",
        "reset_permission": "Réinitialiser l'autorisation"
    },
    "subProjectRulesNames": {
        "Project_List": "Liste des Projets",
        "Project_Create": "Créer un Projet",
        "Project_Name_Edit": "Modifier le Nom du Projet",
        "Project_Sprint_Create": "Créer un Sprint de Projet",
        "Project_folder_Create": "Créer un Dossier de Projet",
        "Project_folder_Name_Edit": "Modifier le Nom du Dossier de Projet",
        "Project_sprint_Name_Edit": "Modifier le Nom du Sprint de Projet",
        "Project_Details": "Détails du Projet",
        "Project_Status_Change": "Changement de Statut du Projet",
        "Project_Assignee": "Assigné au Projet",
        "Project_Category": "Catégorie de Projet",
        "Proejct_Source": "Source du Projet",
        "Project_Type": "Type de Projet",
        "Project_Currency": "Devise du Projet",
        "Project_Amount": "Montant du Projet",
        "Project_Start Date": "Date de Début du Projet",
        "Project_End Date": "Date de Fin du Projet",
        "Project_Due Date": "Date d'Échéance du Projet",
        "Project_Close": "Clôturer le Projet",
        "Project_Description": "Description du Projet",
        "Project_Checklist": "Liste de Contrôle du Projet",
        "Project_Checklist_Assign/remove": "Affecter/Retirer la Liste de Contrôle du Projet",
        "Project_Attachments": "Pièces Jointes du Projet",
        "Project_Milestone": "Jalon du Projet",
        "Task_list": "Liste des Tâches",
        "Task_Create": "Créer une Tâche",
        "Sub_Task_Create": "Créer une Sous-Tâche",
        "Task_Name_Edit": "Modifier le Nom de la Tâche",
        "Task_Status": "Statut de la Tâche",
        "Task_Assignee": "Assigné à la Tâche",
        "Task_Priority": "Priorité de la Tâche",
        "Task_Due_Date": "Date d'Échéance de la Tâche",
        "Task_Estimated_Hours": "Heures Estimées pour la Tâche",
        "Task_Description": "Description de la Tâche",
        "Task_Checklist": "Liste de Contrôle de la Tâche",
        "Task_Checklist_Assign/remove": "Affecter/Retirer la Liste de Contrôle de la Tâche",
        "Task_Attachments": "Pièces Jointes de la Tâche",
        "Show_Tasks": "Afficher les Tâches",
        "Custom_Field": "Champ Personnalisé",
        "Edit_Company": "Modifier l'Entreprise",
        "File_Extensions": "Extensions de Fichiers",
        "Project_Milestone_Status": "Statut du Jalon du Projet",
        "Invite_Member": "Inviter un Membre",
        "Member_list": "Liste des Membres",
        "Create_Team": "Créer une Équipe",
        "Team_List": "Liste des Équipes",
        "Security_&_Permissions": "Sécurité & Permissions",
        "Role_Management": "Gestion des Rôles",
        "Designation": "Désignation",
        "Milestone_Weekly_Range": "Plage Hebdomadaire des Jalons",
        "User_Timesheet": "Feuille de Temps de l'Utilisateur",
        "Project_Timesheet": "Feuille de Temps du Projet",
        "Workload__Timesheet": "Feuille de Temps de Charge de Travail",
        "Milestone_Report": "Rapport de Jalon",
        "Project": "Projet",
        "Task": "Tâche",
        "Company_Settings": "Paramètres de l'Entreprise",
        "Sheet_Settings": "Paramètres de la Feuille",
        "Team_Color": "Couleur de l'Équipe",
        "Team_Name": "Noms des Équipes",
        "Add_Member": "Ajouter un Membre",
        "Add_New_Designation": "Ajouter une Nouvelle Désignation"
    },
    "Notification": {
        "Notification": "Notification",
        "notification_setting": "Paramètres de Notification",
        "browser": "Navigateur",
        "mobile": "Mobile",
        "before": "Avant",
        "chat": "Chat",
        "project": "Projet",
        "tasks": "Tâches",
        "before_project_due_date": "Date d'échéance du projet",
        "before_project_end_date": "Date de fin du projet",
        "before_task_due_date": "Date d'échéance de la tâche",
        "before_task_end_date": "Date de fin de la tâche",
        "message_create": "Création de message",
        "project_create": "Création de projet",
        "project_name": "Nom du projet",
        "project_status_change": "Changement de statut du projet",
        "project_assignee": "Assigné au projet",
        "project_lead": "Chef de projet",
        "project_category": "Catégorie de projet",
        "project_source": "Source du projet",
        "project_type": "Type de projet",
        "project_currency": "Devise du projet",
        "project_amount": "Montant du projet",
        "project_start_date": "Date de début du projet",
        "project_end_date": "Date de fin du projet",
        "project_due_date": "Date d'échéance du projet",
        "project_close": "Clôture du projet",
        "project_description": "Description du projet",
        "project_checklist": "Liste de contrôle du projet",
        "project_checklist_assign": "Affectation de la liste de contrôle du projet",
        "project_checklist_remove": "Suppression de la liste de contrôle du projet",
        "project_attachments": "Pièces jointes du projet",
        "project_milestone": "Jalon du projet",
        "project_milestone_status_change": "Changement de statut du jalon",
        "project_sprint_create": "Création de sprint de projet",
        "project_folder_create": "Création de dossier de projet",
        "comments_im_@mentioned_in": "Commentaires où je suis mentionné",
        "task_notification": "Notification de tâche",
        "task_create": "Création de tâche",
        "task_edit": "Modification de tâche",
        "task_status": "Statut de la tâche",
        "task_assignee": "Assigné à la tâche",
        "task_priority": "Priorité de la tâche",
        "task_type": "Type de tâche",
        "task_due_date": "Date d'échéance de la tâche",
        "task_description": "Description de la tâche",
        "task_checklist": "Liste de contrôle de la tâche",
        "task_checklist_assign": "Affectation de la liste de contrôle de la tâche",
        "task_checklist_remove": "Suppression de la liste de contrôle de la tâche",
        "task_attachments": "Pièces jointes de la tâche",
        "comments_Im_@mentioned_in": "Commentaires où je suis mentionné",
        "logged_hours_notification": "Notification des heures enregistrées",
        "after_3_hours_today_pending_hours": "Après 3 heures aujourd'hui, notification d'heures en attente",
        "task_estimated_hours": "Heures estimées de la tâche"
    },
    "TimeTracker": {
        "TimeTracker": "Suivi du Temps",
        "unlock": "Débloquez l'univers avec Hyphen OI Pro Tracker sur votre bureau !",
        "smooth": "Suivez facilement les heures passées par les utilisateurs sur les projets ou les tâches grâce au suivi du temps.",
        "click": "cliquez",
        "No_Record_Found": "Aucun Enregistrement Trouvé",
        "total": "Total",
        "screenshot_preview": "Aperçu de la capture d'écran",
        "log_time_found_no_screenshot": "Le temps de journalisation a été trouvé, mais aucune capture d'écran n'a été prise pour cette durée"
    },
    "settingslider": {
        "Time Tracking": "Suivi du Temps",
        "Notifications": "Notifications",
        "Company": "Entreprise",
        "My Settings": "Mes Paramètres",
        "Security & Permissions": "Sécurité & Permissions",
        "Upgrade": "Mettre à Niveau",
        "Custom Field Manager": "Gestionnaire de Champs Personnalisés",
        "Templates": "Modèles",
        "Projects": "Projets",
        "Teams": "Équipes",
        "Members": "Membres",
        "Settings": "Paramètres",
        "Change Password": "Changer le mot de passe"
    },
    "Chat": {
        "welcome_message": "Bienvenue chez BRAND_NAME",
        "msg2": "Ceci est un tout nouveau groupe. Voici quelques étapes pour vous aider à démarrer. Pour plus d'informations, consultez notre guide de démarrage.",
        "chats": "Chats",
        "favorites": "Favoris",
        "CHANNELS": "CHAÎNES"
    },
    "Comments": {
        "unread_message": "Messages non lus",
        "more": "plus",
        "less": "moins",
        "edited": "édité",
        "edit": "Modifier",
        "create_task": "Créer une tâche",
        "add_to_checklist": "Ajouter à la liste de contrôle",
        "copy_message": "Copier le message",
        "reply": "Répondre",
        "message": "Message",
        "mark_unread": "Marquer comme non lu",
        "This_message_is_deleted": "Ce message est supprimé",
        "You_deleted_this_message": "Vous avez supprimé ce message",
        "no_user_found": "Aucun utilisateur trouvé.",
        "unlock_comment_view": "Pour déverrouiller la vue des commentaires"
    },
    "PlaceHolder": {
        "enter_task_type": "Entrez le type de tâche",
        "enter_task_status": "Entrez le statut de la tâche",
        "enter_project_status": "Entrez le statut du projet",
        "Enter_Project_Name": "Entrez le nom du projet",
        "Enter_Key_Name": "Entrez le nom de la clé",
        "Select_Category": "Sélectionnez une catégorie",
        "Select_Project_Due_Date": "Sélectionnez la date d'échéance du projet",
        "search": "Chercher",
        "search_here": "Rechercher ici",
        "Type_here": "Tapez ici",
        "Task_name": "Nom de la tâche",
        "Add_description": "Ajouter une description",
        "Enter_Duplicate_Task_Name": "Entrez le nom de la tâche en double",
        "Enter_Text": "Entrez du texte",
        "Enter_Amount": "Entrez le montant",
        "Select": "Sélectionner",
        "Enter_Refund_Amount": "Entrez le montant du remboursement",
        "Enter_Milestone_Name": "Entrez le nom du jalon",
        "Enter_sprint_name": "Entrez le nom du sprint",
        "Enter_directory_name": "Entrez le nom du répertoire",
        "Rename_Tag": "Renommer l'étiquette",
        "Enter_Team_Name": "Entrez le nom de l'équipe",
        "Duration_only_hours": "Durée uniquement en heures",
        "Enter_option": "Entrez l'option",
        "Enter_View_Name": "Entrez le nom de la vue",
        "Enter_URL": "Entrez l'URL",
        "Enter_HTML": "Entrez le HTML",
        "Enter_item_name": "+ Entrez le nom de l'élément",
        "Add_an_item": "+ Ajouter un élément",
        "Enter_Company_Name": "Entrez le nom de l'entreprise",
        "Select_Country": "Sélectionnez le pays",
        "Enter_Template": "Entrez le modèle",
        "Enter_Template_Name": "Entrez le nom du modèle",
        "Project_key_must_be_unique": "La clé du projet doit être unique",
        "Enter_zip": "Entrez le code postal",
        "Enter_GST_Number": "Entrez le numéro GST",
        "Enter_Milestone_Status": "Entrez le statut du jalon",
        "Enter_Priority_Name": "Entrez le nom de la priorité",
        "Enter_File_Extensions_Name": "Entrez le nom des extensions de fichier",
        "Enter_Task_Name": "Entrez le nom de la tâche",
        "Select_State": "Sélectionnez l'état",
        "No_States": "Aucun État",
        "Select_City": "Sélectionnez la ville",
        "No_Cities": "Aucune ville",
        "enter_category_name": "Entrez le nom de la catégorie",
        "enter_channel_name": "Entrez le nom du canal",
        "Pinned_messages": "Messages épinglés",
        "Search": "Recherche",
        "Search_by_name_or_email": "Rechercher par nom ou email",
        "Invite_by_email": "Inviter par email",
        "Select_Designation": "Sélectionnez la désignation",
        "Select_Role": "Sélectionnez le rôle",
        "Enter_designation": "Entrez la désignation",
        "Enter_Description": "Entrez une description",
        "Add_New_Role": "Ajouter un Nouveau Rôle",
        "Enter_role": "Saisir le rôle",
        "Enter_Field_Label": "Entrez l'étiquette de champ",
        "Enter_Placeholder": "Entrez un espace réservé",
        "field_label": "Étiquette du champ",
        "placeholder": "Espace réservé",
        "Enter_Number": "Entrez un nombre"
    },
    "DuplicateTask": {
        "duplicate_task_name": "Nom de la tâche en double",
        "what_do_you_copy": "Que souhaitez-vous copier",
        "everything": "Tout",
        "no_assignee": "Pas de responsable",
        "no_watcher": "Pas de observateur",
        "move_task": "Déplacer la tâche",
        "mearge_task_into": "Fusionner la tâche dans"
    },
    "Converttolist": {
        "are_you_sure_convert": "Êtes-vous sûr de vouloir convertir cette tâche en liste ?",
        "important": "Important",
        "you_will_lose": "Vous perdrez tous les commentaires en thread. Cette action ne peut pas être annulée.",
        "convert_to_list": "Convertir en liste"
    },
    "Billing": {
        "billing_details": "Détails de facturation",
        "plan_details": "Détails du plan",
        "next_msg": "Le montant à payer suivant est",
        "due_on": "Dû le",
        "upgrade_plan": "Mettre à niveau le plan",
        "cancel_subscription": "Annuler l'abonnement",
        "reactivate_subscription": "Réactiver l'abonnement",
        "biling_info": "Informations de facturation",
        "update_billing_info": "Mettre à jour les informations de facturation",
        "contact_support": "Contacter le support",
        "for_help_msg": "Pour obtenir de l'aide et un soutien concernant vos questions de facturation, contactez notre équipe d'assistance et elle se fera un plaisir de vous aider.",
        "payment_methods": "Méthodes de paiement",
        "update_payment_method": "Mettre à jour la méthode de paiement",
        "add_payment_method": "Ajouter un mode de paiement",
        "ending_in": "se terminant par",
        "payment_method_update": "Mise à jour de la méthode de paiement réussie.",
        "waiting_msg": "Votre récente mise à jour de la méthode de paiement prendra effet lors de votre prochaine facture et sera utilisée pour tous les paiements futurs.",
        "error_updating": "Mise à jour de la méthode de paiement non réussie. Nous avons rencontré un problème lors de la mise à jour de votre méthode de paiement. Veuillez réessayer ou contacter le support pour obtenir de l'aide.",
        "card_expires": "La carte expire le",
        "billing_address": "Adresse de facturation",
        "subscription_plan": "Plan d'abonnement",
        "next_renew_date": "Date de renouvellement suivante",
        "storage_use": "Utilisation de l'espace de stockage",
        "address": "Adresse",
        "address_line": "Ligne d'adresse",
        "zip_code": "Code postal",
        "zip": "Code postal",
        "Save_&_Continue": "Enregistrer et continuer",
        "billing_history": "Historique de facturation",
        "Invoices": "Factures",
        "credit_notes": "Notes de crédit",
        "download": "Télécharger",
        "id": "ID",
        "type": "Type",
        "date": "Date",
        "description": "Description",
        "no_of_users": "Nombre d'utilisateurs",
        "amount": "Montant",
        "status": "Statut",
        "pay_now": "Payer maintenant",
        "cancelling_subscription_message": "L'annulation de l'abonnement signifie que votre abonnement se termine le",
        "reactivate_anytime": "Réactivez à tout moment avant cela !",
        "reactivate_confirmation": "Êtes-vous sûr de vouloir réactiver l'abonnement ? En sélectionnant 'Oui', vous réactiverez et reprendrez votre plan de facturation.",
        "amounting_to": "d'un montant de",
        "insufficient_funds": "Fonds insuffisants",
        "payment_successful": "Paiement réussi.",
        "payment_successful_details": "Paiement réussi ! Votre facture est réglée. Veuillez attendre 2 à 3 minutes pour que les modifications prennent effet partout, vous permettant ainsi de profiter pleinement des fonctionnalités et améliorations élargies !",
        "payment_unsuccessful": "Paiement échoué. Nous avons rencontré un problème lors de la mise à niveau de votre plan. Veuillez réessayer ou contacter le support pour obtenir de l'aide.",
        "plan_upgrade_unsuccessful": "Échec de la mise à niveau du plan. Nous avons rencontré un problème lors de la mise à niveau de votre plan. Veuillez vous assurer que la carte dispose d'un solde suffisant.",
        "proceed_with_payment": "Voulez-vous procéder au paiement pour la facture numéro",
        "attention_needed": "Nous avons besoin de votre attention !",
        "avoid_service_disruption": "pour éviter une interruption de service",
        "subscription_renewal_failed": "Le renouvellement automatique de l'abonnement a échoué en raison de",
        "update_payment_method_please": "Veuillez mettre à jour votre mode de paiement",
        "click_here_for_update_payment_method": "Cliquez ici pour mettre à jour le mode de paiement",
        "credit_balance": "Solde de crédit",
        "this_balance_will_be_used_for_a_future_payment": "Ce solde sera utilisé pour un paiement futur.",
        "paymnet_failed_subscription_canceled": "Nous souhaitons vous informer que votre précédente souscription a été annulée. Votre compte a maintenant été basculé vers notre souscription par défaut, qui a certaines fonctionnalités désactivées. Pour activer ces fonctionnalités, veuillez mettre à niveau votre plan.",
        "promotional_credit_balance": "Crédit promotionnel",
        "balance": "Solde",
        "created_on": "Créé le",
        "no_promotional_found": "Aucun historique de crédit promotionnel trouvé"
    },
    "Tour": {
        "tour_completed": "Visite terminée",
        "do_you_have_any": "Avez-vous des questions ? Nous vous encourageons à explorer nos tutoriels vidéo complets de BRAND_NAME pour commencer et tirer le meilleur parti de votre expérience.",
        "watch_video": "Regarder la vidéo",
        "have_brief_tour_alianhub": "Souhaitez-vous faire une visite rapide de BRAND_NAME ?",
        "have_brief_tour_alianhub_view": "Souhaitez-vous faire une visite rapide des vues de BRAND_NAME ?",
        "have_brief_tour_alianhub_left_side": "Souhaitez-vous faire une visite rapide de la liste des projets ?",
        "look_how_to_create": "Découvrez comment créer un projet, gérer des tâches, consulter les rapports de feuille de temps, entrer dans un chat, voir les mentions et notifications, et plus encore.",
        "lets_start": "Commençons",
        "no_thanks": "Non merci",
        "have_brief_task": "Souhaitez-vous faire une visite rapide de la tâche ?",
        "have_brief_tour_project": "Souhaitez-vous faire une visite rapide du projet ?",
        "look_how_to_create_task": "Découvrez comment créer une tâche, gérer une tâche, consulter les tâches selon le groupe d'état, et plus encore.",
        "look_how_to_create_project": "Découvrez comment créer un projet, gérer un projet, consulter les tâches selon le groupe d'état, et plus encore.",
        "project_creation_description": "Les projets peuvent être créés, assignés et suivis en toute simplicité, avec une visibilité claire des responsabilités pour les membres de l'équipe. Cela favorise une meilleure organisation, conduisant à une efficacité et une productivité accrues. Cliquez ici pour démarrer un nouveau projet.",
        "enter_project_name": "Veuillez entrer un nom bref pour votre projet.",
        "enter_project_key": "Veuillez entrer une clé brève pour votre projet.",
        "add_project_category": "Veuillez ajouter une catégorie pour votre projet.",
        "enter_project_duedate": "Veuillez entrer une date d'échéance pour votre projet.",
        "add_project_lead_assignee": "Veuillez ajouter le responsable principal pour votre projet.",
        "create_project_from_template": "Cette option vous permet de créer rapidement un nouveau projet à partir d'un modèle existant, avec des données et des paramètres préconfigurés, ce qui vous permet de reproduire facilement la même configuration de projet.",
        "customize_project_section": "Cette option vous permet de personnaliser entièrement votre projet en configurant divers éléments tels que les statuts, les types, les applications, et bien plus encore, adaptés à vos besoins spécifiques.",
        "task_type_templates_list_text": "Liste des modèles de types de tâches",
        "task_type_templates_description_text": "Cette section affiche les modèles de types de tâches disponibles. Sélectionnez celui qui correspond à vos besoins.",
        "create_new_task_type_template_text": "Créer un nouveau modèle de type de tâche",
        "create_new_task_type_template_description_text": "Cliquez sur le bouton + pour ajouter un nouveau modèle de type de tâche, que vous pourrez ensuite utiliser pour vos tâches.",
        "view_template_task_types_text": "Voir les types de tâches du modèle",
        "view_template_task_types_description_text": "Ici, vous pouvez voir les types de tâches liés au modèle sélectionné. Vous pouvez modifier ou ajouter de nouveaux types de tâches en fonction de vos besoins.",
        "add_new_task_type_text": "Ajouter un nouveau type de tâche",
        "add_new_task_type_description_text": "Cliquez sur le bouton 'Ajouter un type de tâche' pour inclure de nouveaux types de tâches dans le modèle sélectionné.",
        "save_project_as_template_text": "Enregistrer le projet comme modèle",
        "save_project_as_template_description_text": "Cliquez sur 'Enregistrer comme modèle' pour enregistrer la configuration actuelle pour une utilisation dans de futurs projets.",
        "initiate_new_project_text": "Démarrer un nouveau projet",
        "initiate_new_project_description_text": "Cliquez ici pour démarrer un nouveau projet.",
        "add_new_task_text": "Ajouter une nouvelle tâche",
        "input_task_name_text": "Saisir le nom de la tâche",
        "choose_task_status_text": "Choisir le statut de la tâche",
        "assign_task_text": "Attribuer la tâche",
        "set_task_deadline_text": "Définir la date limite de la tâche",
        "define_task_priority_text": "Définir la priorité de la tâche",
        "view_task_list_text": "Voir la liste des tâches",
        "task_information_text": "Informations sur la tâche",
        "quick_task_menu_text": "Menu rapide des tâches",
        "task_actions_text": "Actions de la tâche",
        "subtask_toggle_text": "Basculer les sous-tâches",
        "task_tour_complete_text": "Visite de la tâche terminée",
        "create_new_task_description_text": "Créez une nouvelle tâche en cliquant sur le bouton '+ Nouvelle tâche'.",
        "input_task_name_description_text": "Entrez le nom de la tâche dans le champ de saisie prévu.",
        "choose_task_status_description_text": "Sélectionnez le type de tâche approprié en fonction de vos besoins.",
        "assign_task_description_text": "Sélectionnez la personne à qui la tâche sera attribuée.",
        "set_task_deadline_description_text": "Choisissez une date d'échéance pour la tâche.",
        "define_task_priority_description_text": "Choisissez le niveau de priorité pour la tâche.",
        "view_task_list_description_text": "Ceci est une liste de tâches, affichant leurs détails et regroupées par statut.",
        "task_information_description_text": "Voici les détails de la tâche sélectionnée.",
        "quick_task_menu_description_text": "En cliquant sur l'icône, un menu déroulant avec des options d'opérations de tâches s'ouvrira.",
        "task_actions_description_text": "Sélectionnez une action dans la liste des opérations de tâches disponibles.",
        "subtask_toggle_description_text": "Voici un basculement pour afficher la liste des sous-tâches.",
        "task_tour_complete_description_text": "La visite est terminée. Commencez à explorer les nombreuses possibilités à venir !",
        "search_and_filter_projects_text": "Rechercher et filtrer les projets",
        "search_projects_text": "Rechercher des projets",
        "search_options_for_projects_text": "Options de recherche pour les projets",
        "search_projects_by_name_text": "Rechercher des projets par nom",
        "advanced_project_search_text": "Recherche avancée de projet",
        "filter_projects_by_favorites_text": "Filtrer les projets par favoris",
        "project_settings_text": "Paramètres du projet",
        "project_list_text": "Liste des projets",
        "end_of_project_view_tour_text": "Fin de la visite de la vue du projet",
        "search_and_filter_projects_description_text": "Recherchez et filtrez des projets en fonction de vos critères ici.",
        "enter_search_keywords_text": "Entrez des mots-clés de recherche pour trouver des projets spécifiques.",
        "search_filter_dropdown_description_text": "Cliquez sur l'icône pour ouvrir un menu déroulant avec des filtres de recherche.",
        "toggle_search_options_description_text": "Basculez entre les options pour rechercher par projet, sprint ou dossier au fur et à mesure de la saisie.",
        "advanced_search_icon_description_text": "Cliquez sur l'icône pour effectuer une recherche avancée.",
        "filter_by_favorites_description_text": "Cliquez sur l'icône étoile pour prioriser vos projets favoris en haut de la liste.",
        "project_settings_icon_description_text": "Cliquez sur l'icône des paramètres pour basculer entre les projets archivés ou non archivés.",
        "view_project_list_description_text": "Ici, vous pouvez voir votre liste de projets.",
        "end_of_project_view_tour_description_text": "La visite est maintenant terminée.",
        "create_assign_prioritize_monitor_projects_text": "Créez, attribuez, priorisez et suivez facilement les projets. Les membres de l'équipe peuvent clairement voir leurs tâches, rester organisés et améliorer leur efficacité et leur productivité. Cliquez ici pour initier un nouveau projet.",
        "track_users_time_sheet_reports_text": "Suivez efficacement le temps des utilisateurs avec divers rapports de feuilles de temps tels que la feuille de temps utilisateur, la feuille de temps projet, la feuille de charge de travail et la feuille de suivi. Cliquez ici pour explorer les rapports de feuilles de temps.",
        "user_time_sheet_description_text": "La feuille de temps utilisateur vous permet de suivre les heures enregistrées par chaque utilisateur en fonction de votre rôle.",
        "project_time_sheet_description_text": "Suivez les heures enregistrées pour chaque projet dans la feuille de temps projet en fonction de votre rôle.",
        "workload_time_sheet_description_text": "Similaire à la feuille de temps utilisateur, la feuille de temps de charge de travail inclut également des détails sur la charge de travail de l'utilisateur, le total des heures et les heures estimées.",
        "tracker_sheet_description_text": "La feuille de suivi montre le temps enregistré via le suivi du temps, ainsi que des captures d'écran et le temps total suivi.",
        "view_companies_switch_text": "Voyez toutes les entreprises auxquelles vous êtes associé et passez facilement de l'une à l'autre en en sélectionnant une.",
        "engage_team_real_time_text": "Collaborez avec les membres de l'équipe en temps réel pour une prise de décision rapide. Créez des canaux et partagez des informations via des pièces jointes, des messages vocaux et du texte.",
        "real_time_notifications_text": "Restez informé grâce aux notifications en temps réel sur les activités des projets et des tâches, y compris les affectations de tâches, les changements de statut, les commentaires et les échéances.",
        "address_specific_individuals_text": "Adressez-vous directement à des individus spécifiques dans le système de gestion de projet. Consultez les mentions liées aux tâches, projets ou discussions.",
        "access_personal_information_text": "Accédez à vos informations personnelles, ainsi qu'aux paramètres liés aux entreprises, projets, utilisateurs et sécurité, en fonction de votre rôle.",
        "project_views_list_text": "Liste des vues de projet",
        "add_new_project_view_text": "Ajouter une nouvelle vue de projet",
        "manage_project_views_text": "Gérer les vues de projet",
        "project_files_text": "Fichiers de projet",
        "project_audio_files_text": "Fichiers audio du projet",
        "add_project_watcher_text": "Ajouter un observateur de projet",
        "project_operation_list_text": "Liste des opérations de projet",
        "advanced_task_filter_text": "Filtre avancé des tâches",
        "search_tasks_text": "Rechercher des tâches",
        "search_options_menu_text": "Menu des options de recherche",
        "search_criteria_text": "Critères de recherche",
        "project_views_list_description_text": "Une liste des vues de projet disponibles.",
        "add_new_project_view_description_text": "Créez une nouvelle vue ici.",
        "manage_project_views_description_text": "C'est ici que vous pouvez ajouter ou épingler des vues à un projet. Cliquez sur 'Ajouter une vue' pour ajouter ou sélectionnez 'Épingler une vue' pour l'épingler.",
        "project_files_description_text": "Accédez à tous les fichiers et liens du projet en cliquant sur l'icône.",
        "project_audio_files_description_text": "Cliquez sur l'icône pour voir tous les fichiers audio liés au projet.",
        "add_project_watcher_description_text": "Gérez vos paramètres d'observateur de projet.",
        "project_operation_list_description_text": "Effectuez diverses opérations de projet à partir d'ici.",
        "advanced_task_filter_description_text": "Cliquez sur l'icône pour effectuer une recherche avancée.",
        "search_tasks_description_text": "Entrez des mots-clés pertinents pour rechercher des tâches spécifiques.",
        "search_options_menu_description_text": "Cliquez sur l'icône pour ouvrir un menu déroulant avec différentes options de recherche.",
        "search_criteria_description_text": "Choisissez entre le nom de la tâche, la clé de la tâche ou la description pour affiner votre recherche à mesure que vous tapez.",
        "select_operation_description_text": "Sélectionnez une opération dans la liste pour effectuer l'action souhaitée sur le projet."
    },
    "TaskStatus": {
        "To_Do": "À faire"
    },
    "AI": {
        "generate": "Générer",
        "ai_button": "Écrire avec l'IA",
        "ai_title": "Demandez à l'IA de trouver ou de créer n'importe quoi",
        "write_with_ai": "Écrire avec l'IA",
        "suggest_tasks": "Suggérer des tâches",
        "suggest_subtasks": "Suggérer des sous-tâches",
        "ai_sidebar_placeholder": "Que voudriez-vous que l'IA écrive ?",
        "ai_chat_placeholder": "Dites à l'IA quoi faire ensuite",
        "ai_available_on_paid_plans_upgrade_now": "L'IA est uniquement disponible à l'achat sur nos plans payants. Mettez à niveau et ajoutez l'IA maintenant!",
        "please_upgrade_plan_to_use_ai": "Veuillez mettre à niveau votre plan pour utiliser l'IA.",
        "read_less": "Lire moins",
        "read_more": "Lire la suite",
        "to_unlock_ai": "Pour débloquer l'IA",
        "copy": "Copier",
        "generating_results": "Génération des résultats",
        "hub_ai": "HubAi",
        "regenerate": "Régénérer",
        "title": "Titre",
        "error_occurred_engine_issue": "Une erreur s'est produite. Soit le moteur demandé n'existe pas, soit un autre problème est survenu lors du traitement de votre demande",
        "ai_not_integrated": "L'IA n'est pas intégrée dans votre système",
        "limit_reached": "Vous avez atteint votre limite"
    },
    "Toast": {
        "Your_card_is_expired": "Votre carte est expirée.",
        "Password_set_new_has_been_successfully": "Le nouveau mot de passe a été défini avec succès.",
        "task_created_successfully": "Tâche créée avec succès",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": ", Veuillez supprimer le filtre avancé pour afficher les projets nouvellement créés.",
        "create_task_plan_limit_message": "Mettez à niveau votre plan. Vous avez atteint la limite de création de tâches dans le sprint TASK_SPRINT.",
        "something_went_wrong": "Quelque chose a mal tourné.",
        "file_size_is_larger_than_maxFileSize": "La taille du fichier est supérieure à la taille maximale autorisée.",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "Sélectionnez uniquement des images et le format de fichier d'image doit être FILE_FORMATS.",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "Sélectionnez uniquement des fichiers d'image et le format de fichier d'image doit être FILE_FORMATS.",
        "Multiple_files_not_allowed": "Fichiers multiples non autorisés.",
        "Please_select_valid_file": "Veuillez sélectionner un fichier valide.",
        "require_image_format_message": "Le format de fichier n'est pas pris en charge ou n'est pas ajouté dans les paramètres de l'entreprise. Vous pouvez ajouter le format de fichier dans les paramètres.",
        "You_have_to_add_extension_in_setting": "Vous devez ajouter l'extension dans les paramètres.",
        "Something_went_wrong_Please_try_again": "Quelque chose a mal tourné. Veuillez réessayer.",
        "Company_is_disable": "L'entreprise est désactivée.",
        "advance_search_feature_upgrade_message": "Cette fonctionnalité de recherche avancée n'est pas disponible sur votre plan actuel. Pour déverrouiller la recherche avancée, mettez à niveau votre plan.",
        "Access_Denied": "Accès refusé.",
        "notification_permission": "Pour recevoir des notifications, veuillez autoriser la permission de notification dans les paramètres du site et recharger la page.",
        "Link_is_Copied_to_clipboard": "Le lien a été copié dans le presse-papiers.",
        "Task_Key_is_Copied_to_clipboard": "La clé de tâche a été copiée dans le presse-papiers.",
        "At_least_one_field_is_required": "Au moins un champ est requis.",
        "Task_name_updated_successfully": "Nom de la tâche mis à jour avec succès.",
        "Watcher_added_successfully": "Observateur ajouté avec succès.",
        "Watcher_removed_successfully": "Observateur retiré avec succès.",
        "Nothing_to_update": "Rien à mettre à jour.",
        "Sprint_already_exists": "Le sprint existe déjà",
        "Sprint created successfully": "Sprint créé avec succès.",
        "Sprint restored successfully": "Sprint restauré avec succès.",
        "Sprint closed successfully": "Sprint fermé avec succès.",
        "Sprint archived successfully": "Sprint archivé avec succès.",
        "Sprint deleted successfully": "Sprint supprimé avec succès.",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "Mettez à niveau votre plan. Vous avez atteint la limite de création de sprints.",
        "Folder_already_exists": "Le dossier existe déjà.",
        "Folder created successfully": "Dossier créé avec succès.",
        "Folder updated successfully": "Dossier mis à jour avec succès.",
        "Folder restored successfully": "Dossier restauré avec succès.",
        "Folder closed successfully": "Dossier fermé avec succès.",
        "Folder archived successfully": "Dossier archivé avec succès.",
        "Folder deleted successfully": "Dossier supprimé avec succès.",
        "Status_changed_successfully": "Statut changé avec succès.",
        "Due_date_updated_successfully": "Date d'échéance mise à jour avec succès.",
        "Due_date_not_updated": "Date d'échéance non mise à jour.",
        "Assignee changed successfully": "Responsable changé avec succès.",
        "Assignee added successfully": "Responsable ajouté avec succès.",
        "Assignee removed successfully": "Responsable retiré avec succès.",
        "Assignee not updated": "Responsable non mis à jour.",
        "Task_updated_successfully": "Tâche mise à jour avec succès.",
        "Task_restored_successfully": "Tâche restaurée avec succès.",
        "Task_archived_successfully": "Tâche archivée avec succès.",
        "Task_deleted_successfully": "Tâche supprimée avec succès.",
        "Tag_Deleted_successfully": "Tag supprimé avec succès.",
        "Log_time_added_successfully": "Temps de journal ajouté avec succès.",
        "Filter_saved_successfully": "Filtre enregistré avec succès.",
        "Filter_update_successfully": "Filtre mis à jour avec succès.",
        "Filter_deleted_successfully": "Filtre supprimé avec succès.",
        "Checklist_creted_succesfully.": "Liste de contrôle créée avec succès.",
        "Please_select_checklist": "Veuillez sélectionner une liste de contrôle.",
        "You_have_reached_your_limit": "Votre limite quotidienne a été atteinte.",
        "already_exists": "EXIST_VALUE existe déjà.",
        "Converted_sucessfully": "Converti avec succès.",
        "create_task_limit_in_sprint_upgrade_task_message": "Mettez à niveau votre plan. Vous avez atteint la limite de création de tâches dans le sprint SELECTED_SPRINT_DATA.",
        "Please_Select_Task_Type": "Veuillez sélectionner le type de tâche",
        "Please_Select_Task": "Veuillez sélectionner une tâche",
        "Task_moved_sucessfully": "Tâche déplacée avec succès",
        "Task_not_moved": "Tâche non déplacée",
        "Task_duplicate_sucessfully": "Tâche dupliquée avec succès",
        "Task_not_duplicated": "Tâche non dupliquée",
        "Convert_in_to_task_sucessfully": "Converti en tâche avec succès",
        "Company_name_already_exists": "Le nom de l'entreprise existe déjà",
        "Company_has_been_created_Successfully": "L'entreprise a été créée avec succès.",
        "Custom_field_updated_successfully": "Champ personnalisé mis à jour avec succès",
        "No_assignee_found": "Aucun responsable trouvé",
        "No_due_date_found": "Aucune date d'échéance trouvée",
        "No_self_assignee_found": "Aucun responsable auto-attribué trouvé",
        "Estimated_time_updated_successfully": "Temps estimé mis à jour avec succès",
        "Description_updated_successfully": "Description mise à jour avec succès",
        "Description_not_updated": "Description non mise à jour",
        "Copied": "Copié!",
        "User_removed_successfully": "Utilisateur supprimé avec succès",
        "Invitation_cancelled_successfully": "Invitation annulée avec succès",
        "User_role_changed_successfully": "Rôle de l'utilisateur changé avec succès",
        "User_designation_changed_successfully": "Désignation de l'utilisateur changée avec succès.",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "Veuillez mettre à niveau votre plan pour utiliser le Suivi du temps.",
        "Request_remove_successfully": "Demande supprimée avec succès",
        "Upgrade_Your_Plan": "Mettez à niveau votre plan",
        "Updated_successfully": "Mis à jour avec succès",
        "Deleted_successfully": "Supprimé avec succès",
        "View Pinned": "Voir les épinglés",
        "View Unpinned": "Voir les non épinglés",
        "View_Already_Added": "Voir déjà ajouté",
        "Company_details_saved_successfully": "Les détails de l'entreprise ont été enregistrés avec succès.",
        "Currency_added_successfully": "Monnaie ajoutée avec succès",
        "Currency_removed_successfully": "Monnaie supprimée avec succès",
        "File_extension_remove_successfully": "Extension de fichier FILE_EXTENSION supprimée avec succès",
        "File_extension_update_successfully": "Extension de fichier mise à jour avec succès.",
        "Status_updated_successfully": "Statut mis à jour avec succès",
        "Project_milestone_status_Deleted_successfully": "Statut des jalons de projet supprimé avec succès.",
        "Milestone_weekly_range_updated_successfully": "Plage hebdomadaire des jalons mise à jour avec succès.",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "Les dimensions de l'image ne doivent pas dépasser ImageDimensions pixels.",
        "error_in_uploading_image_please_try_it_again": "Erreur lors du téléchargement de l'image, veuillez réessayer",
        "Task_priority_updated_successfully": "Priorité de la tâche mise à jour avec succès.",
        "Task_priority_Remove_successfully": "Priorité de la tâche supprimée avec succès.",
        "Priority_updated_successfully": "Priorité mise à jour avec succès",
        "Priority_not_updated": "Priorité non mise à jour",
        "error_in_deleting_priority_please_try_it_again": "Erreur lors de la suppression de la priorité, veuillez réessayer",
        "Field_Enable_Successfully": "Champ activé avec succès",
        "Field_Disable_Successfully": "Champ désactivé avec succès",
        "Field_Added_Successfully": "Champ ajouté avec succès",
        "Field_Updated_Successfully": "Champ mis à jour avec succès",
        "Added_to_favourite": "Ajouté aux favoris",
        "Removed_from_favourite": "Retiré des favoris",
        "Tag_Created_successfully": "Tag créé avec succès",
        "Queue list added successfully": "Liste de files d'attente ajoutée avec succès",
        "Queue list removed successfully": "Liste de files d'attente supprimée avec succès",
        "Queue list not updated": "Liste de files d'attente non mise à jour",
        "Attachments_uploaded_successfully": "Pièces jointes téléchargées avec succès",
        "Attachment_removed_successfully": "Pièce jointe supprimée avec succès",
        "Attachment_not_removed": "Pièce jointe non supprimée",
        "Please_try_again": "Veuillez réessayer",
        "Task_name_copied": "Nom de la tâche copié",
        "Status_already_exists": "Le statut existe déjà",
        "Status_added_sucessfully": "Statut ajouté avec succès",
        "Task_Type_already_exists": "Le type de tâche existe déjà",
        "Task_Type_added_sucessfully": "Type de tâche ajouté avec succès",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "La taille de l'image doit être inférieure à ImageDimensions pixels.",
        "Data_deleted_successfully": "Données supprimées avec succès.",
        "Category_created_successfully": "Catégorie créée avec succès",
        "Please_select_an_image_file": "Veuillez sélectionner un fichier image",
        "Channel_created_successfully": "Canal créé avec succès",
        "Folder_not_found": "Dossier non trouvé",
        "Template_&_Project_data_has_been_added_successfully": "Les données de modèle et de projet ont été ajoutées avec succès.",
        "Project_data_has_been_added_successfully": "Les données du projet ont été ajoutées avec succès.{filterMessage}",
        "Error_in_creating_project": "Erreur lors de la création du projet",
        "Milestone_deleted_successfully": "Étape supprimée avec succès",
        "Error_in_deleting_milestone": "Erreur lors de la suppression de l'étape",
        "Milestone_added_successfully": "Étape ajoutée avec succès",
        "Error_in_adding_milestone": "Erreur lors de l'ajout de l'étape",
        "Milestone_update_successfully": "Mise à jour de l'étape réussie",
        "Error_in_updating_milestone": "Erreur lors de la mise à jour de l'étape",
        "Milestone_status_update_successfully": "Mise à jour de l'état de l'étape réussie",
        "Error_in_updating_milestone_status": "Erreur lors de la mise à jour de l'état de l'étape",
        "Milestone_refund_amount_update_successfully": "Mise à jour du montant du remboursement de l'étape réussie",
        "Error_in_updating_milestone_refund_amount": "Erreur lors de la mise à jour du montant du remboursement de l'étape",
        "The_project_not_found": "Le projet n'a pas été trouvé.",
        "The_project_is_archived": "Le projet est archivé.",
        "Start_date_of_project_should_be_smaller_than_current_date": "La date de début du projet doit être antérieure à la date actuelle",
        "All_the_range_is_included_in_milestone": "Toute la plage est incluse dans l'étape",
        "Please_enter_start_date_of_project": "Veuillez entrer la date de début du projet",
        "Project_name_updated_successfully": "Nom du projet mis à jour avec succès",
        "Project_restored_successfully": "Projet restauré avec succès",
        "Project_closed_successfully": "Projet fermé avec succès",
        "Project_archived_successfully": "Projet archivé avec succès",
        "Project_deleted_successfully": "Projet supprimé avec succès",
        "Enter_valid_project_source": "Entrez une source de projet valide",
        "Please_select_sub_task": "Veuillez sélectionner une sous-tâche.",
        "Status_not_updated": "Statut non mis à jour",
        "Start_date_updated_successfully": "Date de début mise à jour avec succès",
        "Start_date_not_updated": "Date de début non mise à jour",
        "Task_converted_sucessfully": "Tâche convertie avec succès",
        "Task_merged_sucessfully": "Tâche fusionnée avec succès",
        "Can_not_create_template_name_Custom": "Impossible de créer le nom du modèle personnalisé",
        "Template_name_updated_successfully": "Nom du modèle mis à jour avec succès.",
        "Template_has_been_created_Successfully": "Le modèle a été créé avec succès.",
        "Template_deleted_successfull": "Modèle supprimé avec succès.",
        "Template_has_been_deleted_successfully": "Le modèle a été supprimé avec succès.",
        "Storage_exceeded_Upgrade_your_plan": "Stockage dépassé. Veuillez mettre à niveau votre plan",
        "max_filesize_messages": "La taille maximale du fichier est de FILE_SIZE Mo.",
        "Password_reset_email_has_been_sent_successfully": "L'e-mail de réinitialisation du mot de passe a été envoyé avec succès",
        "Invalid_username_or_password": "Nom d'utilisateur ou mot de passe invalide.",
        "Email_Not_Verified": "E-mail non vérifié.",
        "Verification_mail_has_been_send_successfully": "L'e-mail de vérification a été envoyé avec succès",
        "Invalid_url": "URL invalide",
        "User_already_registered": "Utilisateur déjà enregistré.",
        "User_has_been_registered_successfully": "L'utilisateur a été enregistré avec succès.",
        "The_email_address_is_already_in_use": "L'adresse e-mail est déjà utilisée",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "L'utilisateur a été enregistré avec succès. Veuillez vérifier votre e-mail pour continuer.",
        "Password_reset_has_been_successfully": "La réinitialisation du mot de passe a été réussie",
        "Your_email_has_been_verify_successfully": "Votre e-mail a été vérifié avec succès",
        "Invitation_accepted_successfully": "Invitation acceptée avec succès",
        "Only_product_owner_can_create_a_company": "Seul le propriétaire du produit peut créer une entreprise",
        "Company_name_must_be_unique": "Le nom de l'entreprise doit être unique.",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Abonnement annulé avec succès. Veuillez permettre 2 à 3 minutes pour que les modifications prennent effet partout.",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "Abonnement réactivé avec succès. Veuillez permettre 2 à 3 minutes pour que les modifications prennent effet partout.",
        "View_name_is_required": "Le nom de la vue est requis",
        "name_should_be_at_least_3_characters_long": "Le nom doit comporter au moins 3 caractères",
        "View_name_already_exists": "Le nom de la vue existe déjà",
        "View_added_successfully": "Vue ajoutée avec succès",
        "View_Deleted_Successfully": "Vue supprimée avec succès",
        "Link_copied_to_clipboard_successfully": "Lien copié dans le presse-papiers avec succès",
        "Project_avatar_updated_successfully": "Avatar du projet mis à jour avec succès",
        "Message pinned successfully": "Message épinglé avec succès",
        "Message unpinned successfully": "Message désépinglé avec succès",
        "Message_copied": "Message copié",
        "Item_cannot_be_empty": "L'élément ne peut pas être vide",
        "Maximum_MAX_CHAR_characters_are_allowed": "Un maximum de MAX_CHAR caractères est autorisé",
        "Item_added_to_checklist": "Élément ajouté à la liste de contrôle",
        "Maximum_10_files_can_be_uploaded_at_once": "Un maximum de 10 fichiers peut être téléchargé à la fois",
        "file_type_is_not_supported": "Le type de fichier n'est pas pris en charge !",
        "ERROR_in_file_upload": "ERREUR lors du téléchargement du fichier",
        "file_size_is_larger_than_FILE_SIZE_mb": "La taille du fichier est supérieure à FILE_SIZE Mo !",
        "Mark_as_favorite_successfully": "Marqué comme favori avec succès",
        "Start_and_Due_date_updated_successfully": "Date de début et date d'échéance mises à jour avec succès",
        "Start_and_Due_date_not_updated": "Date de début et date d'échéance non mises à jour",
        "Attchments_deleted_successfully": "Pièces jointes supprimées avec succès",
        "Designation_is_required": "La désignation est requise",
        "Designation_already_exists": "La désignation existe déjà",
        "Designation_added_successfully": "Désignation ajoutée avec succès",
        "Designation_updated_successfully": "Désignation mise à jour avec succès",
        "Role_is_required": "Le rôle est requis",
        "Role_already_exists": "Le rôle existe déjà",
        "Role_added_successfully": "Rôle ajouté avec succès",
        "Role_updated_successfully": "Rôle mis à jour avec succès",
        "Please_provide_an_email_id": "Veuillez fournir un identifiant e-mail",
        "Please_provide_a_designation": "Veuillez fournir une désignation",
        "Please_provide_a_role": "Veuillez fournir un rôle",
        "Designation_deleted_successfully": "Désignation supprimée avec succès",
        "The_role_is_already_in_use_so_it_can't_be_deleted": "Le rôle est déjà utilisé, donc il ne peut pas être supprimé.",
        "Role_deleted_successfully": "Rôle supprimé avec succès",
        "Language_not_updated": "Langue non mise à jour !",
        "Profile_updated_successfully": "Profil mis à jour avec succès.",
        "Notification_Settings_Update_successfully": "Mise à jour des paramètres de notification réussie",
        "Permission_updated_successfully": "Permission mise à jour avec succès",
        "Per_User_Generate_Limit_value_is_not_valid": "La valeur de la limite de génération par utilisateur n'est pas valide",
        "Team_name_is_required": "Le nom de l'équipe est requis",
        "Minimum_3_character_required": "Minimum 3 caractères requis",
        "Team_name_already_exist": "Le nom de l'équipe existe déjà",
        "Template_has_been_added_successfully": "Le modèle a été ajouté avec succès.",
        "Billing_details_has_been_updated_successfully": "Les détails de facturation ont été mis à jour avec succès",
        "Billing_details_not_updated": "Détails de facturation non mis à jour",
        "Invalid_Card_Details_Please_check_and_try_again": "Détails de carte invalides. Veuillez vérifier et réessayer.",
        "Expired_Card_Please_check_and_try_again": "Carte expirée. Veuillez vérifier et réessayer.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "Code de vérification de carte invalide (CVC). Veuillez vérifier et réessayer.",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "Vous avez annulé votre abonnement actuel à la fin du terme, veuillez réactiver l'abonnement et réessayer.",
        "Plan_not_purchased_Please_try_again": "Plan non acheté. Veuillez réessayer.",
        "Please_fill_out_billing_details_first": "Veuillez d'abord remplir les détails de facturation.",
        "Please_check_your_credential": "Veuillez vérifier vos identifiants.",
        "File_type_not_supported": "Le type de fichier n'est pas pris en charge",
        "Are_you_sure_to_delete_this_file": "Êtes-vous sûr de vouloir supprimer ce fichier ?",
        "Select_Project_Type": "Sélectionner le Type de Projet",
        "Tracker_user_added_successfully": "Utilisateur de suivi ajouté avec succès",
        "Tracker_user_removed_successfully": "Utilisateur de suivi supprimé avec succès",
        "queue_list_not_updated": "QueueList non mis à jour.",
        "upgrade_plan_folder_limit_reached": "Mettez à niveau votre plan. Vous avez atteint la limite de création de dossiers.",
        "View_updated_successfully": "Vue mise à jour avec succès",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "La désignation est déjà utilisée, elle ne peut donc pas être supprimée",
        "Sprint updated successfully": "Sprint mis à jour avec succès.",
        "Project_milestone_status_updated_successfully": "Statut des jalons de projet mis à jour avec succès.",
        "Invalid_email": "Votre email n'est pas valide. Veuillez vérifier et réessayer",
        "Invalid_password": "Votre mot de passe n'est pas valide. Veuillez vérifier et réessayer",
        "Too_many_request": "Trop de demandes. Veuillez réessayer plus tard",
        "Password_reset_link": "E-mail d'expiration du mot de passe envoyé avec succès ! Veuillez vérifier votre boîte de réception pour procéder à la réinitialisation de votre mot de passe.",
        "Project_milestone_status_added_successfully": "Statut du jalon du projet ajouté avec succès.",
        "Please_select_start_end_date": "Veuillez sélectionner les dates de début et de fin",
        "Invitation_canceled": "nvitation annulée : Vous ne pouvez plus utiliser ce lien",
        "Ai_limit_reached": "Votre limite quotidienne a été atteinte",
        "You_have_reached_the_maximum_limit_of_guest_users": "Mettez à niveau votre plan. Vous avez atteint la limite maximale d'utilisateurs invités.",
        "Upgrade_for_import": "Mettez à niveau votre plan pour accéder à la fonctionnalité d'importation.",
        "Upgrade_for_export": "Mettez à niveau votre plan pour accéder à la fonctionnalité d'exportation.",
        "import_task_success": "Vos tâches ont été importées avec succès.",
        "export_task_success": "Tâches exportées avec succès.",
        "export_task_error": "Il n'y a aucune tâche à exporter.",
        "invalid_file_error": "Type de fichier invalide. Veuillez télécharger un fichier .csv.",
        "free_company_limit_reached": "Vous avez atteint la limite maximale pour la création d'entreprises gratuites.",
        "Import_users_successfully": "Utilisateurs importés avec succès.",
        "date_range": "Veuillez sélectionner une plage de dates avant d’appliquer.",
        "Task_total_estimate_update_succesfull": "Mise à jour réussie de l'estimation totale de la tâche"
    },
    "SecurityAndPermission": {
        "project": "Projet",
        "project_list": "Liste des projets",
        "project_create": "Créer un projet",
        "project_name_edit": "Modifier le nom du projet",
        "project_sprint_create": "Créer un sprint de projet",
        "project_folder_create": "Créer un dossier de projet",
        "project_folder_name_edit": "Modifier le nom du dossier de projet",
        "project_sprint_name_edit": "Modifier le nom du sprint de projet",
        "project_details": "Détails du projet",
        "project_status_change": "Changer le statut du projet",
        "project_assignee": "Attribuer le projet",
        "project_category": "Catégorie de projet",
        "project_source": "Source du projet",
        "project_type": "Type de projet",
        "project_currency": "Devise du projet",
        "project_amount": "Montant du projet",
        "project_start_date": "Date de début du projet",
        "project_end_date": "Date de fin du projet",
        "project_due_date": "Date d'échéance du projet",
        "project_close": "Clôturer le projet",
        "project_description": "Description du projet",
        "project_checklist": "Liste de vérification du projet",
        "project_checklist_assign_remove": "Attribuer/supprimer la liste de vérification du projet",
        "project_attachments": "Pièces jointes du projet",
        "project_milestone": "Jalon du projet",
        "task": "Tâche",
        "task_list": "Liste des tâches",
        "task_create": "Créer une tâche",
        "sub_task_create": "Créer une sous-tâche",
        "task_name_edit": "Modifier le nom de la tâche",
        "task_status": "Statut de la tâche",
        "task_assignee": "Attribuer la tâche",
        "task_priority": "Priorité de la tâche",
        "task_due_date": "Date d'échéance de la tâche",
        "task_estimated_hours": "Heures estimées pour la tâche",
        "task_description": "Description de la tâche",
        "task_checklist": "Liste de vérification de la tâche",
        "task_checklist_assign_remove": "Attribuer/supprimer la liste de vérification de la tâche",
        "task_attachments": "Pièces jointes de la tâche",
        "show_tasks": "Afficher les tâches",
        "task_custom_field": "Champ personnalisé",
        "settings": "Paramètres de l'entreprise",
        "settings_edit_company": "Modifier l'entreprise",
        "settings_task_priority": "Priorité de la tâche",
        "settings_file_extensions": "Extensions de fichier",
        "settings_project_milestone_status": "Statut du jalon du projet",
        "settings_invite_member": "Inviter un membre",
        "settings_member_list": "Liste des membres",
        "settings_create_team": "Créer une équipe",
        "settings_team_list": "Liste des équipes",
        "settings_project_list": "Liste des projets",
        "settings_security_permissions": "Sécurité & Permissions",
        "settings_role_management": "Gestion des rôles",
        "settings_designation": "Désignation",
        "milestone_weekly_range": "Plage hebdomadaire du jalon",
        "settings_custom_field": "Champ personnalisé",
        "sheet_settings": "Paramètres de la feuille",
        "user_timesheet": "Feuille de temps utilisateur",
        "project_timesheet": "Feuille de temps du projet",
        "workload_timesheet": "Feuille de temps de la charge de travail",
        "milestone_report": "Rapport de jalon",
        "artificial_intelligence": "Intelligence artificielle",
        "per_user_generate_limit": "Limite de jetons par utilisateur",
        "project_custom_field": "Champ personnalisé",
        "public_projects": "Liste des Projets Publics",
        "tracker_timesheet": "Feuille de Temps du Suivi",
        "view_list": "Voir la liste",
        "chat": "Discussion",
        "project_delete": "Suppression du projet",
        "folder_archive": "Archivage du dossier",
        "folder_delete": "Suppression du dossier",
        "folder_restore": "Restauration du dossier",
        "sprint_type_change": "Changement de type de sprint",
        "sprint_restore": "Restauration du sprint",
        "sprint_delete": "Suppression du sprint",
        "sprint_archive": "Archivage du sprint",
        "chat_channel": "Créer un canal de discussion",
        "chat_category": "Créer une catégorie de discussion",
        "one_to_one_chat": "Chat en tête-à-tête",
        "task_tag": "Étiquette de tâche",
        "task_start_date": "Date de début de tâche",
        "task_activity_log": "Journal d'activité de tâche",
        "task_convert_to_list": "Convertir la tâche en liste",
        "task_convert_to_subtask": "Convertir la tâche en sous-tâche",
        "task_duplicate": "Dupliquer la tâche",
        "task_merge": "Fusionner la tâche",
        "task_move": "Déplacer la tâche",
        "task_archive": "Archiver la tâche",
        "task_delete": "Supprimer la tâche",
        "task_comment": "Commentaire sur la tâche",
        "task_details": "Détail de la tâche",
        "queue_list": "Liste d'attente",
        "advance_search": "Recherche avancée",
        "list_view_column": "Colonne de vue en liste",
        "task_type": "Type de tâche",
        "import_tasks": "Importer des tâches",
        "export_tasks": "Exporter des tâches",
        "convert_to_task": "Convertir en tâche"
    },
    "general": {
        "Continue": "Continuer",
        "New_Status": "Nouveau Statut",
        "Old_Status": "Ancien Statut",
        "Old_Task_Type": "Ancien Type de Tâche",
        "New_Task_Type": "Nouveau Type de Tâche",
        "New_Task_Assignee": "Nouveau Responsable de la Tâche",
        "Old_Task_Assignee": "Ancien Responsable de la Tâche",
        "New_Task_Watchers": "Nouveaux Observateurs de la Tâche",
        "Old_Task_Watchers": "Anciens Observateurs de la Tâche",
        "Select_Status": "Sélectionner le Statut",
        "Select_Task_Type": "Sélectionner le Type de Tâche",
        "No_Assignee": "Aucun Responsable",
        "No_Watchers": "Aucun Observateur",
        "Different_Statuses": "Statuts Différents",
        "Please_Select_Status": "Veuillez Sélectionner un Statut",
        "Tomorrow": "Demain",
        "Yesterday": "Hier",
        "Project": "Projet",
        "Team": "Équipe",
        "User": "Utilisateur",
        "Copy_Assignees": "Copier les assignés",
        "Copy_Watchers": "Copier les observateurs",
        "apply": "Appliquer",
        "current_month": "Mois en cours",
        "current_week": "Semaine en cours",
        "keyboard": "Clavier",
        "mouse": "Souris",
        "Create": "Créer",
        "scroll_to_bottom": "Faire défiler jusqu'en bas",
        "unassigned": "Non assigné",
        "entries": "entrées",
        "showing": "Affichage",
        "page_not_found": "Oups, page introuvable",
        "page_not_found_description": "Nous sommes désolés pour le désagrément. Il semble que vous essayiez d'accéder à une page qui a été supprimée ou qui n'a jamais existé.",
        "note": "Remarque",
        "settings_change_no_effect": "La modification des paramètres ci-dessous n'affectera pas les valeurs actuelles des champs si elles ne sont pas vides",
        "advanced": "Avancé",
        "general": "Général",
        "limits": "Limites",
        "message_deleted": "Message supprimé",
        "company_individual": "Nom de l'entreprise/individu",
        "enter_company_individual": "Entrez le nom de l'entreprise/individu"
    },
    "monthName": {
        "jan": "Jan",
        "feb": "Fév",
        "mar": "Mar",
        "apr": "Avr",
        "may": "Mai",
        "jun": "Juin",
        "jul": "Juil",
        "aug": "Août",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Déc"
    },
    "timeLog": {
        "select_valid_time_duration": "Veuillez sélectionner une durée valide",
        "end_time_field_required": "Le champ de l'heure de fin est requis",
        "start_time_field_required": "Le champ de l'heure de début est requis"
    },
    "weekName": {
        "sun": "Dim",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Jeu",
        "fri": "Ven",
        "sat": "Sam",
        "fridays": "Vendredis",
        "mondays": "Lundis",
        "saturdays": "Samedis",
        "sundays": "Dimanches",
        "thursdays": "Jeudis",
        "tuesdays": "Mardis",
        "wednesdays": "Mercredis"
    },
    "tooltipText": {
        "enable_app_manage_priority": "En activant cette application, vous pourrez gérer la <b>Priorité</b> dans les <b>Tâches</b> pour ce <b>projet</b>",
        "enable_app_manage_multiple_assignee": "En activant cette application, vous pourrez gérer plusieurs <b>Assignés</b> dans les <b>Tâches</b> pour ce <b>projet</b>",
        "enable_app_manage_time_estimates": "En activant cette application, vous pourrez gérer les <b>Estimations de temps</b> dans les <b>Tâches</b> pour ce <b>projet</b>",
        "enable_app_use_milestones": "En activant cette application, vous pourrez utiliser les <b>Étapes</b> pour ce <b>projet</b>",
        "enable_app_manage_tags": "En activant cette application, vous pourrez gérer les <b>Étiquettes</b> dans les <b>Tâches</b> pour ce <b>projet</b>",
        "enable_app_manage_custom_fields": "En activant cette application, vous pourrez gérer les <b>Champs personnalisés</b> pour ce <b>projet</b>",
        "enable_app_manage_time_log": "En activant cette application, vous pourrez gérer le <b>Journal de temps</b> dans les <b>Tâches</b> pour ce <b>projet</b>",
        "enable_app_use_ai_operations": "En activant cette application, vous pourrez utiliser les <b>Opérations AI</b> pour ce <b>projet</b>"
    },
    "Company": {
        "fill_company_details": "Remplissez les détails de votre entreprise",
        "set_up_company": "Configurez votre entreprise",
        "creating_company": "Création de l'entreprise",
        "company_created": "Votre entreprise a été créée. Nous avons configuré les étapes initiales. Veuillez patienter un moment.",
        "good_to_go": "Prêt à partir",
        "select_default_country": "Sélectionnez le pays par défaut",
        "freelimitreachedstart": "Vous avez déjà créé une entreprise gratuite. Pour créer une nouvelle entreprise, vous devez d'abord passer à un plan payant",
        "freelimitreachedend": "Une fois la mise à niveau effectuée, vous serez prêt à ajouter une autre entreprise gratuite."
    },
    "Subscription": {
        "subscription_cancelled": "Vous avez annulé votre abonnement à la fin de la période d'abonnement en cours",
        "discard_changes": "L'ajout d'un utilisateur à votre abonnement annulera ces modifications, et votre abonnement actuel continuera à partir du prochain cycle de facturation.",
        "confirm_terminate_schedule": "Êtes-vous sûr de vouloir annuler la planification de l'annulation de l'abonnement ?",
        "confirm_add_user": "Êtes-vous sûr de vouloir ajouter un utilisateur à votre abonnement ?",
        "confirm_remove_user": "Êtes-vous sûr de vouloir retirer l'utilisateur de l'abonnement ?",
        "next_invoice_amount": "Votre prochaine facture sera de",
        "credits_applied": "Crédits appliqués",
        "current_billing_for_upgrade": "Facturation actuelle pour la mise à niveau",
        "plan_upgrade_success": "Félicitations ! La mise à niveau de votre plan a été planifiée avec succès, et les améliorations prendront effet après la fin de la période actuelle. Préparez-vous à profiter des fonctionnalités et des avantages améliorés lors de la prochaine phase de votre abonnement.",
        "subscription_upgrade_from": "Votre abonnement sera amélioré à partir de",
        "total_payable_amount": "Montant total à payer",
        "update_subscription": "Mettre à jour l'abonnement",
        "updated_subscription_price": "Prix de l'abonnement mis à jour",
        "upgrade_subscription": "Améliorer l'abonnement",
        "confirm_subscription_change": "Êtes-vous sûr de vouloir changer votre abonnement de",
        "monthly": "Mois",
        "yearly": "An",
        "remove_scheduled_cancellation_confirmation": "En cliquant sur 'Oui', vous annulerez l'annulation programmée et votre cycle de facturation se poursuivra.",
        "scheduled_cancellation_notice": "Vous avez une annulation programmée de votre abonnement actuel le",
        "credit_entitlement_congratulations": "Félicitations ! Vous avez droit à un crédit de",
        "credit_note_application": "pour votre abonnement actuel. Cette note de crédit sera appliquée sans effort pour améliorer votre abonnement et sera également automatiquement déduite de vos prochaines factures, garantissant une valeur continue et des économies tout au long de votre parcours d'abonnement.",
        "invoice_period_coverage": "La facture couvre la période du"
    },
    "Card": {
        "pay_with": "Payer avec",
        "add_new_card": "Ajouter une nouvelle carte",
        "name_on_card": "Nom sur la carte",
        "card_number": "Numéro de carte",
        "expiry": "Expiration",
        "cvc": "CVC"
    },
    "alertBox": {
        "updateBillingAddress": "Vous devez mettre à jour la première adresse de facturation",
        "valid_csv_title": "Aucun fichier téléchargé",
        "valid_csv_text": "Veuillez télécharger un fichier .csv valide afin de continuer.",
        "ok": "OK",
        "cancel": "Annuler",
        "go_back_title": "Retourner en arrière ?",
        "go_back_text": "Êtes-vous sûr de vouloir revenir à l'étape précédente ?",
        "close_modal_title": "Fermer la fenêtre ?",
        "close_modal_text": "Êtes-vous sûr de vouloir fermer la fenêtre ? Toutes vos données jusqu'à cette étape seront perdues.",
        "no": "Non",
        "yes": "Oui",
        "confirm": "Confirmer",
        "improper_header_selection_title": "Sélection inappropriée",
        "improper_header_selection_text": "La ligne sélectionnée contient des valeurs non textuelles. Veuillez sélectionner une autre ligne.",
        "missing_fields_title": "Champs obligatoires manquants",
        "missing_fields_text": "Les champs obligatoires suivants doivent être associés et confirmés avant de continuer.",
        "warning_title": "Avertissement",
        "warning_text": "Si vous continuez, toutes les valeurs vides dans 'Priorité de la tâche' et 'Statut' seront respectivement définies sur 'Moyenne' et 'À faire'.",
        "incomplete_mapping_title": "Association incomplète",
        "incomplete_mapping_text": "Veuillez associer toutes les valeurs uniques à au moins une valeur Hyphen OI Pro afin de continuer.",
        "invalid_tasks_error": "Aucune tâche valide trouvée. Veuillez vous assurer que les champs requis ne sont pas vides."
    },
    "importTaskButton": {
        "import_title": "Importer des tâches",
        "import_button": "Importer les tâches depuis un CSV",
        "back_button": "Retour",
        "next_button": "Continuer",
        "export_button": "Exporter en CSV",
        "import_processing": "Vos tâches sont en cours d'importation."
    },
    "importCsvAndSetHeader": {
        "download": "Télécharger",
        "demo_csv": "CSV de démonstration",
        "down_demo_text": "et comparez-le à votre fichier d'importation pour vous assurer que votre fichier est bien formaté.",
        "upload_button": "Téléchargez votre fichier CSV ici",
        "upload_instructions": "Vous pouvez télécharger n'importe quel fichier .csv avec n'importe quel ensemble de colonnes, à condition qu'il contienne un enregistrement par ligne. L'étape suivante vous permettra d'associer vos colonnes de feuille de calcul aux bons points de données. Vous pourrez nettoyer ou supprimer les données corrompues avant de finaliser votre rapport.",
        "header_row_question": "La ligne sélectionnée contient-elle des en-têtes de colonnes ?",
        "select_another_button": "Sélectionner une autre ligne",
        "confirm_row_btt": "Confirmer"
    },
    "headerMapping": {
        "title": "Association des en-têtes",
        "mapping_instructions": "Associons vos en-têtes avec ceux de Hyphen OI Pro",
        "pending_count": "Champs en attente :",
        "confirmed_count": "Champs confirmés :",
        "ignored_count": "Champs ignorés :",
        "custom_count": "Champs personnalisés :",
        "confirmed_text": "Confirmé",
        "ignored_text": "Ignoré",
        "edit_button": "Modifier",
        "no_match_title": "Aucune correspondance",
        "no_match": "Aucune correspondance trouvée",
        "no_match_description": "Ce champ ne correspond à aucun de nos en-têtes. Veuillez l’ignorer ou l’inclure comme champ personnalisé.",
        "custom_field_button": "Inclure comme champ personnalisé",
        "ignore_field_button": "Ignorer ce champ",
        "matched_to_field": "Associé au champ :",
        "duplication_warning": "Ce champ est un doublon et ne peut pas être confirmé. Veuillez choisir un champ différent.",
        "confirm_map_button": "Confirmer l'association"
    },
    "reviewMaping": {
        "title": "Veuillez examiner vos données associées à nos champs. (Vous pouvez également modifier les valeurs des données ici.)",
        "warning": "Un ou plusieurs champs obligatoires contiennent des valeurs manquantes ou invalides. Veuillez les examiner, sinon ces lignes ne seront pas importées."
    },
    "valueMapping": {
        "user_mapping_title": "Association des utilisateurs",
        "user_mapping_instruction": "Associez les utilisateurs aux utilisateurs de Hyphen OI Pro afin de conserver les assignés, les responsables et l'activité des tâches. Si vous ne mappez pas les utilisateurs, les données ne seront PAS importées, car elles ne pourront pas être synchronisées avec Hyphen OI Pro.",
        "user_dropdown_text": "Sélectionner un utilisateur",
        "status_mapping_title": "Association des statuts",
        "status_mapping_instruction": "Pour garantir la cohérence des futurs flux de travail, veuillez associer vos statuts aux valeurs existantes de Hyphen OI Pro. Cela aidera à éviter toute incohérence à l'avenir.",
        "status_dropdown_text": "Sélectionner un statut",
        "priority_mapping_title": "Association des priorités",
        "priority_mapping_instruction": "Pour garantir la cohérence des futurs flux de travail, veuillez associer vos priorités aux valeurs existantes de Hyphen OI Pro. Cela aidera à éviter toute incohérence à l'avenir.",
        "priority_dropdown_text": "Sélectionner une priorité",
        "custom_field_mapping_title": "Association des champs personnalisés",
        "custom_field_mapping_instruction": "Pour garantir la cohérence des futurs flux de travail, veuillez associer le type de vos champs personnalisés aux types existants de Hyphen OI Pro. Cela aidera à éviter toute incohérence à l'avenir.",
        "custom_delimiters_quest": "ℹ️ Avez-vous des délimiteurs séparant les valeurs de ce champ personnalisé ?"
    },
    "importMappingKeywords": {
        "task_id_description": "L'ID de la tâche particulière.",
        "task_name_description": "Le nom de la tâche, généralement un bref résumé.",
        "task_description_description": "Informations détaillées sur la tâche.",
        "task_assignee_description": "L'adresse e-mail de la personne assignée à la tâche.",
        "task_parentId_description": "L'ID de la tâche parente à laquelle cette tâche est associée.",
        "task_leaderId_description": "L'ID utilisateur de la personne dirigeant cette tâche.",
        "task_priority_description": "Le niveau d'importance attribué à la tâche.",
        "task_status_description": "L'état actuel ou l'avancement de la tâche.",
        "task_start_date_description": "La date de début de la tâche.",
        "task_due_date_description": "La date à laquelle la tâche doit être terminée."
    },
    "Affiliate": {
        "refer_earn": "Parrainez et gagnez",
        "unlimited": "Illimité",
        "invite_start_earning_cash_rewards": "Invitez vos amis et commencez à gagner des récompenses en argent.",
        "your_referral_code": "Votre code de parrainage",
        "invite_spend_message": "Pour chaque dépense de votre ami, vous recevrez {percentage}% de ce montant en récompense.",
        "inviteText": "Invitez des amis en partageant ce lien",
        "copy": "Copier",
        "refferal_code_label": "Code de parrainage",
        "refferal_code_placeholder": "Entrez le code de parrainage",
        "invalid_refferal_model_title": "Votre code de parrainage est invalide",
        "invalid_refferal_model_confirm_text": "Oui, créez-le!",
        "invalid_refferal_model_text": "Êtes-vous sûr de vouloir créer une entreprise?",
        "refferal_code_error": "Le code de parrainage n'est pas valide"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "Afficher un graphique à barres de vos tâches totales par assigné",
        "tasks_by_assignee_bar_chart_title": "Tâches par assigné",
        "task_list_description": "Créer une vue en liste à partir des tâches de n'importe quel emplacement",
        "tasks_list_title": "Liste des tâches",
        "tasks_by_assignee_stack_bar_chart_description": "Afficher une représentation empilée de vos tâches totales par assigné",
        "tasks_by_assignee_stack_bar_chart_title": "Tâches par assigné",
        "workload_by_status_stack_bar_chart_description": "Afficher une répartition de vos statuts sur plusieurs emplacements",
        "workload_by_status_stack_bar_chart_title": "Charge de travail par statut",
        "tasks_by_assignee_pie_chart_description": "Afficher un graphique en secteurs de vos tâches totales par assigné",
        "tasks_by_assignee_pie_chart_title": "Tâches par assigné",
        "workload_by_status_pie_chart_description": "Afficher un graphique en secteurs de l'utilisation de vos statuts sur plusieurs emplacements",
        "workload_by_status_pie_chart_title": "Charge de travail par statut",
        "workload_by_status_bar_chart_description": "Afficher un graphique à barres de l'utilisation de vos statuts sur plusieurs emplacements",
        "workload_by_status_bar_chart_title": "Charge de travail par statut",
        "queue_list_title": "Liste d'attente",
        "queue_list_description": "Afficher une liste de vos tâches avec leurs statuts.",
        "card_name": "nom de la carte",
        "location": "projet",
        "group_by": "grouper par",
        "show_assignees": "afficher les assignés",
        "include_subtasks": "inclure les sous-tâches",
        "display_labels_as_percent": "afficher les étiquettes en pourcentage",
        "show_legend": "afficher la légende",
        "show_Data_Labels": "afficher les étiquettes de données",
        "select": "sélectionner",
        "add_card": "Ajouter une carte",
        "back": "Retour",
        "error_assignees": "Le champ afficher les assignés est requis",
        "error_location": "Le champ emplacement est requis",
        "empty_layout_container": "Votre tableau de bord est vide. Cliquez sur 'Ajouter une carte' pour commencer.",
        "status": "statut",
        "edit_card": "modifier la carte",
        "calendar_card_title": "Calendrier",
        "calendar_card_description": "Ceci est une vue calendrier pour les tâches",
        "measure": "mesure",
        "calculation": "calcul",
        "total_urgent_tasks": "Total des tâches urgentes",
        "total_urgent_tasks_description": "Afficher le nombre total de tâches urgentes par emplacement",
        "time_tracker": "Suivi du temps",
        "time_estimate": "Estimation du temps",
        "range": "Plage",
        "max": "Max",
        "min": "Min",
        "median": "Médiane",
        "average": "Moyenne",
        "sum": "Somme",
        "workload_estination_title": "Rapport de temps",
        "workload_estination_description": "Voir les tâches avec le temps suivi et estimé.",
        "workload_only_estination_title": "Temps estimé",
        "workload_only_estination_description": "Voir le temps estimé.",
        "time_only_estination_title": "Temps enregistré",
        "time_only_estination_description": "Voir le temps enregistré.",
        "today": "Aujourd'hui",
        "yesterday": "Hier",
        "this_week": "Cette semaine",
        "last_week": "La semaine dernière",
        "this_month": "Ce mois-ci",
        "last_month": "Le mois dernier",
        "this_year": "Cette année",
        "last_30_days": "Les 30 derniers jours",
        "task": "Nombre de tâches",
        "task_label": "Étiquette de tâche",
        "both": "Afficher les deux",
        "manual_time": "Afficher uniquement le temps manuel",
        "track_time": "Afficher uniquement le temps suivi",
        "logtype": "Journaux de temps",
        "timerange": "Période de temps",
        "priority": "Priorité",
        "due_date": "Date d'échéance",
        "none": "Aucun",
        "total_time_track_description": "Afficher le temps total suivi",
        "total_time_track_tasks": "Temps total suivi",
        "total_tasks_count_description": "Afficher le nombre total de tâches",
        "total_tasks_count": "Nombre total de tâches",
        "assignees": "Personnes assignées",
        "feature": "Fonctionnalité",
        "workload": "Charge de travail",
        "time_tracking": "Suivi du temps",
        "task_card": "Tâches",
        "Today": "Aujourd'hui",
        "Yesterday": "Hier",
        "Tomorrow": "Demain",
        "This_week": "Cette semaine",
        "Next_week": "Semaine prochaine",
        "Next_seven_days": "Prochains 7 jours",
        "Last_seven_days": "7 derniers jours",
        "Last_month": "Mois dernier",
        "This_month": "Ce mois-ci",
        "Next_month": "Mois prochain",
        "Date_range": "Plage de dates",
        "me_mode": "moi",
        "data": "Données",
        "display": "Afficher",
        "fields": "Champs"
    },
    "designationMapping": {
        "title": "Cartographie des Désignations",
        "description": "Veuillez associer les désignations de votre CSV aux désignations existantes dans Hyphen OI Pro."
    },
    "roleMapping": {
        "title": "Cartographie des Rôles",
        "description": "Veuillez associer les rôles de votre CSV aux rôles existants dans Hyphen OI Pro."
    },
    "importUserKeywords": {
        "user_email_description": "Identifiant e-mail de l'utilisateur",
        "user_role_description": "Le rôle ou l'intitulé du poste attribué à l'utilisateur au sein de l'organisation.",
        "user_designation_description": "L'intitulé officiel du poste ou la désignation de l'employé au sein de l'entreprise."
    },
    "userSelection": {
        "title": "Sélection des Utilisateurs",
        "user_limit_error": "Limite maximale d'utilisateurs atteinte. Veuillez mettre à niveau votre plan pour importer plus d'utilisateurs.",
        "description": "Sélectionnez tous les utilisateurs que vous souhaitez importer.",
        "duplicate_email_error": "Cet identifiant e-mail existe déjà dans Hyphen OI Pro. Vous ne pouvez pas l'importer.",
        "invalid_email": "Cet identifiant e-mail est invalide. Veuillez utiliser un identifiant valide.",
        "invalid_fields": "Vous avez un ou plusieurs champs invalides. Veuillez vérifier les champs surlignés.",
        "user_limit_100": "Vous pouvez importer un maximum de 100 utilisateurs à la fois."
    },
    "importUserButton": {
        "import_user_processing": "Vos utilisateurs sont en cours d'importation."
    },
    "timeForecastingReport": {
        "project_name": "Nom du projet",
        "project_status": "Statut du projet",
        "start_date": "Date de début",
        "due_date": "Date d'échéance",
        "last_logged_date": "Dernière date enregistrée",
        "budget": "Budget",
        "actual": "Réel",
        "forecast": "Prévision",
        "estimated_hours": "Heures estimées",
        "logged_hours": "Heures enregistrées",
        "remaining_hours": "Heures restantes",
        "overdue_hours": "Heures en retard",
        "estimated_time_to_complete": "Temps estimé pour terminer",
        "estimated_complition_date": "Date d'achèvement estimée",
        "show_legends": "Afficher les légendes",
        "show_data_labels": "Afficher les étiquettes de données",
        "report_type": "Type de rapport"
    }
}